import srankImage from '../../img/rank/s_rank.webp';
import arankImage from '../../img/rank/a_rank.webp';
import brankImage from '../../img/rank/b_rank.webp';
import crankImage from '../../img/rank/c_rank.webp';
// 電話番号
export const APP_TEL = '086-441-8523';
// 有効無効・真偽等　汎用判定用の定数
export const VALID_VALUE = 1;
export const INVALID_VALUE = 0;
export var CrudStatusEnum;
(function (CrudStatusEnum) {
    CrudStatusEnum[CrudStatusEnum["RegisterForm"] = 1] = "RegisterForm";
    CrudStatusEnum[CrudStatusEnum["RegisterConfirm"] = 2] = "RegisterConfirm";
    CrudStatusEnum[CrudStatusEnum["RegisterComplete"] = 3] = "RegisterComplete";
    CrudStatusEnum[CrudStatusEnum["DeleteConfirm"] = 4] = "DeleteConfirm";
})(CrudStatusEnum || (CrudStatusEnum = {}));
export const CrudStatusList = [
    { key: CrudStatusEnum.RegisterForm, value: "入力" },
    { key: CrudStatusEnum.RegisterConfirm, value: "確認" },
    { key: CrudStatusEnum.RegisterComplete, value: "完了" },
    { key: CrudStatusEnum.DeleteConfirm, value: "削除確認" }
];
// 有料会員登録ステップ
export var SubscriptionRegistStepEnum;
(function (SubscriptionRegistStepEnum) {
    SubscriptionRegistStepEnum[SubscriptionRegistStepEnum["INPUT_BASIC_INFO"] = 1] = "INPUT_BASIC_INFO";
    SubscriptionRegistStepEnum[SubscriptionRegistStepEnum["UPLOAD_IMAGES"] = 2] = "UPLOAD_IMAGES";
    SubscriptionRegistStepEnum[SubscriptionRegistStepEnum["INPUT_CREDITCARD_INFO"] = 3] = "INPUT_CREDITCARD_INFO";
    SubscriptionRegistStepEnum[SubscriptionRegistStepEnum["BEFORE_CONFIRM"] = 4] = "BEFORE_CONFIRM";
    SubscriptionRegistStepEnum[SubscriptionRegistStepEnum["CONFIRM"] = 5] = "CONFIRM";
    SubscriptionRegistStepEnum[SubscriptionRegistStepEnum["COMPLETE"] = 99] = "COMPLETE";
})(SubscriptionRegistStepEnum || (SubscriptionRegistStepEnum = {}));
/*inputの属性*/
export var InputTypeEnum;
(function (InputTypeEnum) {
    InputTypeEnum["TEXT"] = "text";
    InputTypeEnum["NUMBER"] = "number";
    InputTypeEnum["PASSWORD"] = "password";
    InputTypeEnum["TEL"] = "tel";
})(InputTypeEnum || (InputTypeEnum = {}));
// スキル
export var HeroSkill;
(function (HeroSkill) {
    HeroSkill[HeroSkill["SkillA"] = 1] = "SkillA";
    HeroSkill[HeroSkill["SkillB"] = 2] = "SkillB";
    HeroSkill[HeroSkill["SkillC"] = 3] = "SkillC";
    HeroSkill[HeroSkill["SkillD"] = 4] = "SkillD";
    HeroSkill[HeroSkill["SkillE"] = 5] = "SkillE";
})(HeroSkill || (HeroSkill = {}));
// スキル一覧
export const HeroSkillList = [
    { key: HeroSkill.SkillA, value: 'スキルA' },
    { key: HeroSkill.SkillB, value: 'スキルB' },
    { key: HeroSkill.SkillC, value: 'スキルC' },
    { key: HeroSkill.SkillD, value: 'スキルD' },
    { key: HeroSkill.SkillE, value: 'スキルE' },
];
export const HeroSkillUseSelectMulti = HeroSkillList.map((element) => {
    return {
        value: element.key,
        label: element.value,
    };
});
export const searchAll = 9999;
const allObject = { key: searchAll, value: '全て' };
export const selectNone = 0;
const noneObject = { key: selectNone, value: '選択してください' };
export var PrefectureEnum;
(function (PrefectureEnum) {
    PrefectureEnum[PrefectureEnum["Hokkaido"] = 1] = "Hokkaido";
    PrefectureEnum[PrefectureEnum["Aomori"] = 2] = "Aomori";
    PrefectureEnum[PrefectureEnum["Iwate"] = 3] = "Iwate";
    PrefectureEnum[PrefectureEnum["Miyagi"] = 4] = "Miyagi";
    PrefectureEnum[PrefectureEnum["Akita"] = 5] = "Akita";
    PrefectureEnum[PrefectureEnum["Yamagata"] = 6] = "Yamagata";
    PrefectureEnum[PrefectureEnum["Hukushima"] = 7] = "Hukushima";
    PrefectureEnum[PrefectureEnum["Ibaraki"] = 8] = "Ibaraki";
    PrefectureEnum[PrefectureEnum["Tochigi"] = 9] = "Tochigi";
    PrefectureEnum[PrefectureEnum["Gunma"] = 10] = "Gunma";
    PrefectureEnum[PrefectureEnum["Saitama"] = 11] = "Saitama";
    PrefectureEnum[PrefectureEnum["Chiba"] = 12] = "Chiba";
    PrefectureEnum[PrefectureEnum["Tokyo"] = 13] = "Tokyo";
    PrefectureEnum[PrefectureEnum["Kanagawa"] = 14] = "Kanagawa";
    PrefectureEnum[PrefectureEnum["Niigata"] = 15] = "Niigata";
    PrefectureEnum[PrefectureEnum["Toyama"] = 16] = "Toyama";
    PrefectureEnum[PrefectureEnum["Ishikawa"] = 17] = "Ishikawa";
    PrefectureEnum[PrefectureEnum["Hukui"] = 18] = "Hukui";
    PrefectureEnum[PrefectureEnum["Yamanashi"] = 19] = "Yamanashi";
    PrefectureEnum[PrefectureEnum["Nagano"] = 20] = "Nagano";
    PrefectureEnum[PrefectureEnum["Gifu"] = 21] = "Gifu";
    PrefectureEnum[PrefectureEnum["Shizuoka"] = 22] = "Shizuoka";
    PrefectureEnum[PrefectureEnum["Aichi"] = 23] = "Aichi";
    PrefectureEnum[PrefectureEnum["Mie"] = 24] = "Mie";
    PrefectureEnum[PrefectureEnum["Shiga"] = 25] = "Shiga";
    PrefectureEnum[PrefectureEnum["Kyoto"] = 26] = "Kyoto";
    PrefectureEnum[PrefectureEnum["Osaka"] = 27] = "Osaka";
    PrefectureEnum[PrefectureEnum["Hyogo"] = 28] = "Hyogo";
    PrefectureEnum[PrefectureEnum["Nara"] = 29] = "Nara";
    PrefectureEnum[PrefectureEnum["Wakayama"] = 30] = "Wakayama";
    PrefectureEnum[PrefectureEnum["Tottori"] = 31] = "Tottori";
    PrefectureEnum[PrefectureEnum["Shimane"] = 32] = "Shimane";
    PrefectureEnum[PrefectureEnum["Okayama"] = 33] = "Okayama";
    PrefectureEnum[PrefectureEnum["Hiroshima"] = 34] = "Hiroshima";
    PrefectureEnum[PrefectureEnum["Yamaguchi"] = 35] = "Yamaguchi";
    PrefectureEnum[PrefectureEnum["Tokushima"] = 36] = "Tokushima";
    PrefectureEnum[PrefectureEnum["Kagawa"] = 37] = "Kagawa";
    PrefectureEnum[PrefectureEnum["Ehime"] = 38] = "Ehime";
    PrefectureEnum[PrefectureEnum["Kochi"] = 39] = "Kochi";
    PrefectureEnum[PrefectureEnum["Fukuoka"] = 40] = "Fukuoka";
    PrefectureEnum[PrefectureEnum["Saga"] = 41] = "Saga";
    PrefectureEnum[PrefectureEnum["Nagasaki"] = 42] = "Nagasaki";
    PrefectureEnum[PrefectureEnum["Kumamoto"] = 43] = "Kumamoto";
    PrefectureEnum[PrefectureEnum["Oita"] = 44] = "Oita";
    PrefectureEnum[PrefectureEnum["Miyazaki"] = 45] = "Miyazaki";
    PrefectureEnum[PrefectureEnum["Kagoshima"] = 46] = "Kagoshima";
    PrefectureEnum[PrefectureEnum["Okinawa"] = 47] = "Okinawa";
})(PrefectureEnum || (PrefectureEnum = {}));
export const prefectureList = [
    { key: PrefectureEnum.Hokkaido, value: '北海道' },
    { key: PrefectureEnum.Aomori, value: '青森県' },
    { key: PrefectureEnum.Iwate, value: '岩手県' },
    { key: PrefectureEnum.Miyagi, value: '宮城県' },
    { key: PrefectureEnum.Akita, value: '秋田県' },
    { key: PrefectureEnum.Yamagata, value: '山形県' },
    { key: PrefectureEnum.Hukushima, value: '福島県' },
    { key: PrefectureEnum.Ibaraki, value: '茨城県' },
    { key: PrefectureEnum.Tochigi, value: '栃木県' },
    { key: PrefectureEnum.Gunma, value: '群馬県' },
    { key: PrefectureEnum.Saitama, value: '埼玉県' },
    { key: PrefectureEnum.Chiba, value: '千葉県' },
    { key: PrefectureEnum.Tokyo, value: '東京都' },
    { key: PrefectureEnum.Kanagawa, value: '神奈川県' },
    { key: PrefectureEnum.Niigata, value: '新潟県' },
    { key: PrefectureEnum.Toyama, value: '富山県' },
    { key: PrefectureEnum.Ishikawa, value: '石川県' },
    { key: PrefectureEnum.Hukui, value: '福井県' },
    { key: PrefectureEnum.Yamanashi, value: '山梨県' },
    { key: PrefectureEnum.Nagano, value: '長野県' },
    { key: PrefectureEnum.Gifu, value: '岐阜県' },
    { key: PrefectureEnum.Shizuoka, value: '静岡県' },
    { key: PrefectureEnum.Aichi, value: '愛知県' },
    { key: PrefectureEnum.Mie, value: '三重県' },
    { key: PrefectureEnum.Shiga, value: '滋賀県' },
    { key: PrefectureEnum.Kyoto, value: '京都府' },
    { key: PrefectureEnum.Osaka, value: '大阪府' },
    { key: PrefectureEnum.Hyogo, value: '兵庫県' },
    { key: PrefectureEnum.Nara, value: '奈良県' },
    { key: PrefectureEnum.Wakayama, value: '和歌山県' },
    { key: PrefectureEnum.Tottori, value: '鳥取県' },
    { key: PrefectureEnum.Shimane, value: '島根県' },
    { key: PrefectureEnum.Okayama, value: '岡山県' },
    { key: PrefectureEnum.Hiroshima, value: '広島県' },
    { key: PrefectureEnum.Yamaguchi, value: '山口県' },
    { key: PrefectureEnum.Tokushima, value: '徳島県' },
    { key: PrefectureEnum.Kagawa, value: '香川県' },
    { key: PrefectureEnum.Ehime, value: '愛媛県' },
    { key: PrefectureEnum.Kochi, value: '高知県' },
    { key: PrefectureEnum.Fukuoka, value: '福岡県' },
    { key: PrefectureEnum.Saga, value: '佐賀県' },
    { key: PrefectureEnum.Nagasaki, value: '長崎県' },
    { key: PrefectureEnum.Kumamoto, value: '熊本県' },
    { key: PrefectureEnum.Oita, value: '大分県' },
    { key: PrefectureEnum.Miyazaki, value: '宮崎県' },
    { key: PrefectureEnum.Kagoshima, value: '鹿児島県' },
    { key: PrefectureEnum.Okinawa, value: '沖縄県' },
];
export const prefectureSearch = [allObject, ...prefectureList];
export const prefectureWithNone = [noneObject, ...prefectureList];
// 事業者所属
export var CompanyBelongsEnum;
(function (CompanyBelongsEnum) {
    CompanyBelongsEnum[CompanyBelongsEnum["INDIVIDUAL"] = 0] = "INDIVIDUAL";
    CompanyBelongsEnum[CompanyBelongsEnum["COMPANY"] = 1] = "COMPANY";
})(CompanyBelongsEnum || (CompanyBelongsEnum = {}));
export const companyBelongsList = [
    { key: CompanyBelongsEnum.INDIVIDUAL, value: '個人' },
    { key: CompanyBelongsEnum.COMPANY, value: '法人' },
];
export var Gender;
(function (Gender) {
    Gender[Gender["Men"] = 1] = "Men";
    Gender[Gender["Women"] = 2] = "Women";
})(Gender || (Gender = {}));
export const GenderList = [
    { key: Gender.Men, value: '男性' },
    { key: Gender.Women, value: '女性' },
];
export var UserType;
(function (UserType) {
    UserType[UserType["User"] = 0] = "User";
    UserType[UserType["Minion"] = 1] = "Minion";
})(UserType || (UserType = {}));
export const UserTypeList = [
    { key: UserType.User, value: '職人' },
    { key: UserType.Minion, value: '子方' },
];
export const UserTypeSearch = [allObject, ...UserTypeList];
//サイドバー、別タブで遷移させる場合のoption
export var SidebarOption;
(function (SidebarOption) {
    SidebarOption["Blank"] = "SidebarOptionBlank";
    SidebarOption["Accordion"] = "SidebarOptionAccordion";
})(SidebarOption || (SidebarOption = {}));
// ログイン種別
export var LoginType;
(function (LoginType) {
    LoginType["User"] = "user";
    LoginType["Company"] = "company";
    LoginType["Minion"] = "minion";
})(LoginType || (LoginType = {}));
export const LoginTypeList = [
    { key: LoginType.User, value: '職人' },
    { key: LoginType.Minion, value: '子方' },
    { key: LoginType.Company, value: '事業者' },
];
export const SortedLoginTypeList = [
    { key: LoginType.Company, value: '発注者' },
    { key: LoginType.User, value: '受注者' },
    { key: LoginType.Minion, value: '子方' },
];
/* ヒーローランク */
export var HeroRankEnum;
(function (HeroRankEnum) {
    HeroRankEnum[HeroRankEnum["NoRank"] = 0] = "NoRank";
    HeroRankEnum[HeroRankEnum["CRank"] = 1] = "CRank";
    HeroRankEnum[HeroRankEnum["BRank"] = 2] = "BRank";
    HeroRankEnum[HeroRankEnum["ARank"] = 3] = "ARank";
    HeroRankEnum[HeroRankEnum["SRank"] = 4] = "SRank";
})(HeroRankEnum || (HeroRankEnum = {}));
export const HeroRankList = [
    { key: HeroRankEnum.SRank, value: 'Sランク', name: 'srank', rank: 'S', image: srankImage },
    { key: HeroRankEnum.ARank, value: 'Aランク', name: 'arank', rank: 'A', image: arankImage },
    { key: HeroRankEnum.BRank, value: 'Bランク', name: 'brank', rank: 'B', image: brankImage },
    { key: HeroRankEnum.CRank, value: 'Cランク', name: 'crank', rank: 'C', image: crankImage },
];
// スコアとランクの対応
// export const UserRankFromScore = [
//     { range: { min: 0, max: 22 }, rank: HeroRankEnum.CRank },
//     { range: { min: 23, max: 54 }, rank: HeroRankEnum.BRank },
//     { range: { min: 55, max: 88 }, rank: HeroRankEnum.ARank },
//     { range: { min: 89, max: 100 }, rank: HeroRankEnum.SRank }
// ];
export const HeroRankUseSelectMulti = HeroRankList.map((element) => {
    return ({
        value: element.key,
        label: element.value
    });
});
//地方の定義
export var LocalEnum;
(function (LocalEnum) {
    LocalEnum[LocalEnum["Hokkaido"] = 1] = "Hokkaido";
    LocalEnum[LocalEnum["Touhoku"] = 2] = "Touhoku";
    LocalEnum[LocalEnum["Kantou"] = 3] = "Kantou";
    LocalEnum[LocalEnum["Chubu"] = 4] = "Chubu";
    LocalEnum[LocalEnum["Kinki"] = 5] = "Kinki";
    LocalEnum[LocalEnum["ChugokuShikoku"] = 6] = "ChugokuShikoku";
    LocalEnum[LocalEnum["KyushuOkinawa"] = 7] = "KyushuOkinawa";
})(LocalEnum || (LocalEnum = {}));
export const LocalList = [
    { key: LocalEnum.Hokkaido, value: '北海道地方' },
    { key: LocalEnum.Touhoku, value: "東北地方" },
    { key: LocalEnum.Kantou, value: "関東地方" },
    { key: LocalEnum.Chubu, value: "中部地方" },
    { key: LocalEnum.Kinki, value: "近畿地方" },
    { key: LocalEnum.ChugokuShikoku, value: "中国・四国地方" },
    { key: LocalEnum.KyushuOkinawa, value: "九州・沖縄地方" }
];
export const LocalUseSelectMulti = LocalList.map((element) => {
    return {
        value: element.key,
        label: element.value,
    };
});
// 工期
export var JobinfoWorkingPeriodEnum;
(function (JobinfoWorkingPeriodEnum) {
    JobinfoWorkingPeriodEnum[JobinfoWorkingPeriodEnum["WithinMonth"] = 1] = "WithinMonth";
    JobinfoWorkingPeriodEnum[JobinfoWorkingPeriodEnum["WithinHalfYear"] = 2] = "WithinHalfYear";
    JobinfoWorkingPeriodEnum[JobinfoWorkingPeriodEnum["WithinYear"] = 3] = "WithinYear";
    JobinfoWorkingPeriodEnum[JobinfoWorkingPeriodEnum["Years"] = 4] = "Years";
})(JobinfoWorkingPeriodEnum || (JobinfoWorkingPeriodEnum = {}));
// 工期一覧
export const JobinfoWorkingPeriodList = [
    { key: JobinfoWorkingPeriodEnum.WithinMonth, value: '1ヶ月以内' },
    { key: JobinfoWorkingPeriodEnum.WithinHalfYear, value: '1ヶ月〜半年以内' },
    { key: JobinfoWorkingPeriodEnum.WithinYear, value: '半年〜1年以内' },
    { key: JobinfoWorkingPeriodEnum.Years, value: '1年以上' },
];
export const JobinfoWorkingPeriodListMulti = JobinfoWorkingPeriodList.map((element) => {
    return {
        value: element.key,
        label: element.value,
    };
});
//給与の検索、月給か日給か
export var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum[PaymentTypeEnum["Monthly"] = 0] = "Monthly";
    PaymentTypeEnum[PaymentTypeEnum["Daily"] = 1] = "Daily";
})(PaymentTypeEnum || (PaymentTypeEnum = {}));
export const PaymentTypeList = [
    { key: PaymentTypeEnum.Monthly, value: '月給' },
    { key: PaymentTypeEnum.Daily, value: '日給' },
];
export var payment;
(function (payment) {
    payment[payment["under6500"] = 1] = "under6500";
    payment[payment["over6500"] = 2] = "over6500";
    payment[payment["over7000"] = 3] = "over7000";
    payment[payment["over8000"] = 4] = "over8000";
    payment[payment["over9000"] = 5] = "over9000";
    payment[payment["over10000"] = 6] = "over10000";
    payment[payment["over12000"] = 7] = "over12000";
    payment[payment["over15000"] = 8] = "over15000";
    payment[payment["over20000"] = 9] = "over20000";
    payment[payment["under15"] = 100] = "under15";
    payment[payment["over15"] = 101] = "over15";
    payment[payment["over18"] = 102] = "over18";
    payment[payment["over20"] = 103] = "over20";
    payment[payment["over21"] = 104] = "over21";
    payment[payment["over22"] = 105] = "over22";
    payment[payment["over23"] = 106] = "over23";
    payment[payment["over24"] = 107] = "over24";
    payment[payment["over25"] = 108] = "over25";
    payment[payment["over26"] = 109] = "over26";
    payment[payment["over27"] = 110] = "over27";
    payment[payment["over28"] = 111] = "over28";
    payment[payment["over30"] = 112] = "over30";
    payment[payment["over40"] = 113] = "over40";
    payment[payment["over50"] = 114] = "over50";
})(payment || (payment = {}));
export const DailyPaymentBase = [
    { key: payment.under6500, value: '6,500円未満' },
    { key: payment.over6500, value: '6,500円以上' },
    { key: payment.over7000, value: '7,000円以上' },
    { key: payment.over8000, value: '8,000円以上' },
    { key: payment.over9000, value: '9,000円以上' },
    { key: payment.over10000, value: '10,000円以上' },
    { key: payment.over12000, value: '12,000円以上' },
    { key: payment.over15000, value: '15,000円以上' },
    { key: payment.over20000, value: '20,000円以上' },
];
export const DailyPaymentList = [{ key: searchAll, value: '指定なし' }, ...DailyPaymentBase];
export const DailyPaymentRegisterList = [noneObject, ...DailyPaymentBase];
export const MonthlyPaymentBase = [
    { key: payment.under15, value: '15万円未満' },
    { key: payment.over15, value: '15万円以上' },
    { key: payment.over18, value: '18万円以上' },
    { key: payment.over20, value: '20万円以上' },
    { key: payment.over21, value: '21万円以上' },
    { key: payment.over22, value: '22万円以上' },
    { key: payment.over23, value: '23万円以上' },
    { key: payment.over24, value: '24万円以上' },
    { key: payment.over25, value: '25万円以上' },
    { key: payment.over26, value: '26万円以上' },
    { key: payment.over27, value: '27万円以上' },
    { key: payment.over28, value: '28万円以上' },
    { key: payment.over30, value: '30万円以上' },
    { key: payment.over40, value: '40万円以上' },
    { key: payment.over50, value: '50万円以上' },
];
export const MonthlyPaymentList = [{ key: searchAll, value: '指定なし' }, ...MonthlyPaymentBase];
export const MonthlyPaymentRegisterList = [noneObject, ...MonthlyPaymentBase];
export const PaymentBase = [
    ...DailyPaymentBase, ...MonthlyPaymentBase
];
//並び替えタイプ
export var SortTypeEnum;
(function (SortTypeEnum) {
    SortTypeEnum[SortTypeEnum["Desc"] = 0] = "Desc";
    SortTypeEnum[SortTypeEnum["Asc"] = 1] = "Asc";
})(SortTypeEnum || (SortTypeEnum = {}));
// お仕事
//その他条件
export var JobOtherConditionEnum;
(function (JobOtherConditionEnum) {
    JobOtherConditionEnum[JobOtherConditionEnum["UsuallyHighWayFee"] = 1] = "UsuallyHighWayFee";
    JobOtherConditionEnum[JobOtherConditionEnum["FuelFee"] = 2] = "FuelFee";
    JobOtherConditionEnum[JobOtherConditionEnum["HolidayWorkWage"] = 3] = "HolidayWorkWage";
    JobOtherConditionEnum[JobOtherConditionEnum["OverWorkWage"] = 4] = "OverWorkWage";
    JobOtherConditionEnum[JobOtherConditionEnum["NightWorkWage"] = 5] = "NightWorkWage";
    JobOtherConditionEnum[JobOtherConditionEnum["HotelsParkingFee"] = 6] = "HotelsParkingFee";
    JobOtherConditionEnum[JobOtherConditionEnum["BreafastAndDiner"] = 7] = "BreafastAndDiner";
})(JobOtherConditionEnum || (JobOtherConditionEnum = {}));
export const JobOtherConditionList = [
    { key: JobOtherConditionEnum.UsuallyHighWayFee, value: '通常高速代' },
    { key: JobOtherConditionEnum.FuelFee, value: '通勤ガソリン代' },
    { key: JobOtherConditionEnum.HolidayWorkWage, value: '休日出勤手当' },
    { key: JobOtherConditionEnum.OverWorkWage, value: '残業割増' },
    { key: JobOtherConditionEnum.NightWorkWage, value: '深夜割増' },
    { key: JobOtherConditionEnum.HotelsParkingFee, value: '宿泊施設の駐車場有' },
    { key: JobOtherConditionEnum.BreafastAndDiner, value: '出張朝夕食事付' },
];
// 宿泊施設
export var JobHotelsEnum;
(function (JobHotelsEnum) {
    JobHotelsEnum[JobHotelsEnum["Single"] = 1] = "Single";
    JobHotelsEnum[JobHotelsEnum["Twin"] = 2] = "Twin";
    JobHotelsEnum[JobHotelsEnum["OverTwin"] = 3] = "OverTwin";
    JobHotelsEnum[JobHotelsEnum["house"] = 4] = "house";
    JobHotelsEnum[JobHotelsEnum["hotel"] = 5] = "hotel";
    JobHotelsEnum[JobHotelsEnum["myhome"] = 6] = "myhome";
})(JobHotelsEnum || (JobHotelsEnum = {}));
export const JobHotelsList = [
    { key: JobHotelsEnum.Single, value: '一人部屋' },
    { key: JobHotelsEnum.Twin, value: '二人部屋' },
    { key: JobHotelsEnum.OverTwin, value: '多数一室(3名以上1室等)' },
    { key: JobHotelsEnum.house, value: '一戸(各個室・風呂、トイレ共有)' },
    { key: JobHotelsEnum.hotel, value: 'ホテル等' },
    { key: JobHotelsEnum.myhome, value: '自宅通勤' },
];
//仕事の単価一覧
export var JobinfoUnitPriceEnum;
(function (JobinfoUnitPriceEnum) {
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_1"] = 1] = "UnitPrice_1";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_2"] = 2] = "UnitPrice_2";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_3"] = 3] = "UnitPrice_3";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_4"] = 4] = "UnitPrice_4";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_5"] = 5] = "UnitPrice_5";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_6"] = 6] = "UnitPrice_6";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_7"] = 7] = "UnitPrice_7";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_8"] = 8] = "UnitPrice_8";
    JobinfoUnitPriceEnum[JobinfoUnitPriceEnum["UnitPrice_9"] = 9] = "UnitPrice_9";
})(JobinfoUnitPriceEnum || (JobinfoUnitPriceEnum = {}));
export const JobInfoUnitPriceList = [
    noneObject,
    { key: JobinfoUnitPriceEnum.UnitPrice_1, value: '6,500円未満' },
    { key: JobinfoUnitPriceEnum.UnitPrice_2, value: '6,500円以上' },
    { key: JobinfoUnitPriceEnum.UnitPrice_3, value: '7,000円以上' },
    { key: JobinfoUnitPriceEnum.UnitPrice_4, value: '8,000円以上' },
    { key: JobinfoUnitPriceEnum.UnitPrice_5, value: '9,000円以上' },
    { key: JobinfoUnitPriceEnum.UnitPrice_6, value: '10,000円以上' },
    { key: JobinfoUnitPriceEnum.UnitPrice_7, value: '12,000円以上' },
    { key: JobinfoUnitPriceEnum.UnitPrice_8, value: '15,000円以上' },
    { key: JobinfoUnitPriceEnum.UnitPrice_9, value: '20,000円以上' },
];
//求人ー雇用形態のタイプ
export var EmploymentStatusEnum;
(function (EmploymentStatusEnum) {
    //    PartTime = ,
    EmploymentStatusEnum[EmploymentStatusEnum["FullTime"] = 1] = "FullTime";
    EmploymentStatusEnum[EmploymentStatusEnum["Contract"] = 2] = "Contract";
    EmploymentStatusEnum[EmploymentStatusEnum["SubContract"] = 3] = "SubContract";
})(EmploymentStatusEnum || (EmploymentStatusEnum = {}));
export const EmplymentStatusList = [
    { key: EmploymentStatusEnum.FullTime, value: '正社員' },
    //    { key: EmploymentStatusEnum.PartTime, value: 'アルバイト' },
    { key: EmploymentStatusEnum.Contract, value: '契約社員' },
    { key: EmploymentStatusEnum.SubContract, value: '業務委託' },
];
//求人-福利厚生のタイプ
export var RecruitmentWelfareEnum;
(function (RecruitmentWelfareEnum) {
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_1"] = 1] = "Welfare_1";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_2"] = 2] = "Welfare_2";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_3"] = 3] = "Welfare_3";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_4"] = 4] = "Welfare_4";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_5"] = 5] = "Welfare_5";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_6"] = 6] = "Welfare_6";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_7"] = 7] = "Welfare_7";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_8"] = 8] = "Welfare_8";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_9"] = 9] = "Welfare_9";
    RecruitmentWelfareEnum[RecruitmentWelfareEnum["Welfare_10"] = 10] = "Welfare_10";
})(RecruitmentWelfareEnum || (RecruitmentWelfareEnum = {}));
export const RecruitmentWelfareList = [
    { key: RecruitmentWelfareEnum.Welfare_1, value: '社会保険完備' },
    { key: RecruitmentWelfareEnum.Welfare_2, value: '寮完備' },
    { key: RecruitmentWelfareEnum.Welfare_3, value: '通勤手当' },
    { key: RecruitmentWelfareEnum.Welfare_4, value: '住宅手当' },
    { key: RecruitmentWelfareEnum.Welfare_5, value: '作業着などの貸与' },
    { key: RecruitmentWelfareEnum.Welfare_6, value: '食事補助' },
    { key: RecruitmentWelfareEnum.Welfare_7, value: '役職手当' },
    { key: RecruitmentWelfareEnum.Welfare_8, value: '家族手当' },
    { key: RecruitmentWelfareEnum.Welfare_9, value: '資格手当' },
    { key: RecruitmentWelfareEnum.Welfare_10, value: '子育て支援' },
];
//求人-雇用期間のタイプ
export var RecruitmentEmploymentPeriodEnum;
(function (RecruitmentEmploymentPeriodEnum) {
    RecruitmentEmploymentPeriodEnum[RecruitmentEmploymentPeriodEnum["Period_1"] = 1] = "Period_1";
    RecruitmentEmploymentPeriodEnum[RecruitmentEmploymentPeriodEnum["Period_2"] = 2] = "Period_2";
})(RecruitmentEmploymentPeriodEnum || (RecruitmentEmploymentPeriodEnum = {}));
export const RecruitmentEmploymentPeriodList = [
    noneObject,
    { key: RecruitmentEmploymentPeriodEnum.Period_1, value: '期間の定めあり' },
    { key: RecruitmentEmploymentPeriodEnum.Period_2, value: '期間の定めなし' },
];
//時間作成
const hoursmake = () => {
    let hoursArray = [];
    for (let hours = 0; hours <= 23; hours++) {
        hoursArray = [...hoursArray, { key: hours, value: hours + ':00' }];
    }
    return hoursArray;
};
export const hoursList = hoursmake();
//purchaseの購入タイプ
export var PurchaseTypeEnum;
(function (PurchaseTypeEnum) {
    PurchaseTypeEnum[PurchaseTypeEnum["PurchaseTypeSingle"] = 0] = "PurchaseTypeSingle";
    PurchaseTypeEnum[PurchaseTypeEnum["PurchaseTypePack"] = 1] = "PurchaseTypePack";
})(PurchaseTypeEnum || (PurchaseTypeEnum = {}));
//エントリーのステータス
export var EntryStatusEnum;
(function (EntryStatusEnum) {
    EntryStatusEnum[EntryStatusEnum["Application"] = 0] = "Application";
    EntryStatusEnum[EntryStatusEnum["Examination"] = 1] = "Examination";
    EntryStatusEnum[EntryStatusEnum["Reject"] = 2] = "Reject";
    EntryStatusEnum[EntryStatusEnum["Contract"] = 3] = "Contract";
})(EntryStatusEnum || (EntryStatusEnum = {}));
export const EntryStatusJobinfoList = [
    { key: EntryStatusEnum.Application, value: '受付' },
    { key: EntryStatusEnum.Contract, value: '成約' },
    { key: EntryStatusEnum.Examination, value: '検討中' },
    { key: EntryStatusEnum.Reject, value: '見送り' },
];
export const EntryStatusRecruitmentList = [
    { key: EntryStatusEnum.Application, value: '受付' },
    { key: EntryStatusEnum.Contract, value: '採用' },
    { key: EntryStatusEnum.Examination, value: '検討中' },
    { key: EntryStatusEnum.Reject, value: '見送り' },
];
export const ConfirmMessage = '以下の内容で登録してもよろしいでしょうか';
export const CompleteMessage = '登録が完了しました';
export const ErrorMessage = 'エラーが発生しました';
export const ValidationErrMessage = '入力値に誤りがあります';
export const deleteConfirmMessage = '削除してもよろしいでしょうか';
export const deleteCompleteMessage = '削除が完了しました';
export var JobIsConstructionChangeableEnum;
(function (JobIsConstructionChangeableEnum) {
    JobIsConstructionChangeableEnum[JobIsConstructionChangeableEnum["impossible"] = 0] = "impossible";
    JobIsConstructionChangeableEnum[JobIsConstructionChangeableEnum["possible"] = 1] = "possible";
})(JobIsConstructionChangeableEnum || (JobIsConstructionChangeableEnum = {}));
export var MessageFileTypeEnum;
(function (MessageFileTypeEnum) {
    MessageFileTypeEnum[MessageFileTypeEnum["none"] = 0] = "none";
    MessageFileTypeEnum[MessageFileTypeEnum["image"] = 1] = "image";
    MessageFileTypeEnum[MessageFileTypeEnum["other"] = 2] = "other";
})(MessageFileTypeEnum || (MessageFileTypeEnum = {}));
// 画像CROP サイズ 4:5
export const quarterFifthCrop = {
    unit: '%',
    width: 100,
    height: 80,
    aspect: 5 / 4,
    x: 50,
    y: 50,
};
// userのログインステータス
export var UserLoginStatus;
(function (UserLoginStatus) {
    UserLoginStatus[UserLoginStatus["invalid"] = 0] = "invalid";
    UserLoginStatus[UserLoginStatus["valid"] = 1] = "valid";
})(UserLoginStatus || (UserLoginStatus = {}));
//companyのログインステータス
export var CompanyLoginStatus;
(function (CompanyLoginStatus) {
    CompanyLoginStatus[CompanyLoginStatus["invalid"] = 0] = "invalid";
    CompanyLoginStatus[CompanyLoginStatus["valid"] = 1] = "valid";
})(CompanyLoginStatus || (CompanyLoginStatus = {}));
//職人、資格
export var Certification;
(function (Certification) {
    Certification[Certification["Certification_1"] = 1] = "Certification_1";
    Certification[Certification["Certification_2"] = 2] = "Certification_2";
    Certification[Certification["Certification_3"] = 3] = "Certification_3";
    Certification[Certification["Certification_4"] = 4] = "Certification_4";
    Certification[Certification["Certification_5"] = 5] = "Certification_5";
    Certification[Certification["Certification_6"] = 6] = "Certification_6";
    Certification[Certification["Certification_7"] = 7] = "Certification_7";
    Certification[Certification["Certification_8"] = 8] = "Certification_8";
    Certification[Certification["Certification_9"] = 9] = "Certification_9";
    Certification[Certification["Certification_10"] = 10] = "Certification_10";
    Certification[Certification["Certification_11"] = 11] = "Certification_11";
    Certification[Certification["Certification_12"] = 12] = "Certification_12";
    Certification[Certification["Certification_13"] = 13] = "Certification_13";
    Certification[Certification["Certification_14"] = 14] = "Certification_14";
    Certification[Certification["Certification_15"] = 15] = "Certification_15";
    Certification[Certification["Certification_16"] = 16] = "Certification_16";
    Certification[Certification["Certification_17"] = 17] = "Certification_17";
    Certification[Certification["Certification_18"] = 18] = "Certification_18";
    Certification[Certification["Certification_19"] = 19] = "Certification_19";
    Certification[Certification["Certification_20"] = 20] = "Certification_20";
    Certification[Certification["Certification_21"] = 21] = "Certification_21";
    Certification[Certification["Certification_22"] = 22] = "Certification_22";
    Certification[Certification["Certification_23"] = 23] = "Certification_23";
    Certification[Certification["Certification_24"] = 24] = "Certification_24";
    Certification[Certification["Certification_25"] = 25] = "Certification_25";
    Certification[Certification["Certification_26"] = 26] = "Certification_26";
    Certification[Certification["Certification_27"] = 27] = "Certification_27";
    Certification[Certification["Certification_28"] = 28] = "Certification_28";
    Certification[Certification["Certification_29"] = 29] = "Certification_29";
    Certification[Certification["Certification_30"] = 30] = "Certification_30";
    Certification[Certification["Certification_31"] = 31] = "Certification_31";
    Certification[Certification["Certification_32"] = 32] = "Certification_32";
    Certification[Certification["Certification_33"] = 33] = "Certification_33";
    Certification[Certification["Certification_34"] = 34] = "Certification_34";
    Certification[Certification["Certification_35"] = 35] = "Certification_35";
    Certification[Certification["Certification_36"] = 36] = "Certification_36";
    Certification[Certification["Certification_37"] = 37] = "Certification_37";
    Certification[Certification["Certification_38"] = 38] = "Certification_38";
    Certification[Certification["Certification_39"] = 39] = "Certification_39";
    Certification[Certification["Certification_40"] = 40] = "Certification_40";
    Certification[Certification["Certification_41"] = 41] = "Certification_41";
    Certification[Certification["Certification_42"] = 42] = "Certification_42";
    Certification[Certification["Certification_43"] = 43] = "Certification_43";
    Certification[Certification["Certification_44"] = 44] = "Certification_44";
    Certification[Certification["Certification_45"] = 45] = "Certification_45";
    Certification[Certification["Certification_46"] = 46] = "Certification_46";
    Certification[Certification["Certification_47"] = 47] = "Certification_47";
    Certification[Certification["Certification_48"] = 48] = "Certification_48";
    Certification[Certification["Certification_49"] = 49] = "Certification_49";
    Certification[Certification["Certification_50"] = 50] = "Certification_50";
    Certification[Certification["Certification_51"] = 51] = "Certification_51";
    Certification[Certification["Certification_52"] = 52] = "Certification_52";
    Certification[Certification["Certification_53"] = 53] = "Certification_53";
    Certification[Certification["Certification_54"] = 54] = "Certification_54";
    Certification[Certification["Certification_55"] = 55] = "Certification_55";
    Certification[Certification["Certification_56"] = 56] = "Certification_56";
    Certification[Certification["Certification_57"] = 57] = "Certification_57";
    Certification[Certification["Certification_58"] = 58] = "Certification_58";
    Certification[Certification["Certification_59"] = 59] = "Certification_59";
    Certification[Certification["Certification_60"] = 60] = "Certification_60";
    Certification[Certification["Certification_61"] = 61] = "Certification_61";
    Certification[Certification["Certification_62"] = 62] = "Certification_62";
    Certification[Certification["Certification_63"] = 63] = "Certification_63";
    Certification[Certification["Certification_64"] = 64] = "Certification_64";
    Certification[Certification["Certification_65"] = 65] = "Certification_65";
    Certification[Certification["Certification_66"] = 66] = "Certification_66";
    Certification[Certification["Certification_67"] = 67] = "Certification_67";
    Certification[Certification["Certification_68"] = 68] = "Certification_68";
    Certification[Certification["Certification_69"] = 69] = "Certification_69";
    Certification[Certification["Certification_70"] = 70] = "Certification_70";
    Certification[Certification["Certification_71"] = 71] = "Certification_71";
    Certification[Certification["Certification_72"] = 72] = "Certification_72";
    Certification[Certification["Certification_73"] = 73] = "Certification_73";
    Certification[Certification["Certification_74"] = 74] = "Certification_74";
    Certification[Certification["Certification_75"] = 75] = "Certification_75";
    Certification[Certification["Certification_76"] = 76] = "Certification_76";
    Certification[Certification["Certification_77"] = 77] = "Certification_77";
    Certification[Certification["Certification_78"] = 78] = "Certification_78";
    Certification[Certification["Certification_79"] = 79] = "Certification_79";
    Certification[Certification["Certification_80"] = 80] = "Certification_80";
    Certification[Certification["Certification_81"] = 81] = "Certification_81";
    Certification[Certification["Certification_82"] = 82] = "Certification_82";
    Certification[Certification["Certification_83"] = 83] = "Certification_83";
    Certification[Certification["Certification_84"] = 84] = "Certification_84";
    Certification[Certification["Certification_85"] = 85] = "Certification_85";
    Certification[Certification["Certification_86"] = 86] = "Certification_86";
    Certification[Certification["Certification_87"] = 87] = "Certification_87";
    Certification[Certification["Certification_88"] = 88] = "Certification_88";
    Certification[Certification["Certification_89"] = 89] = "Certification_89";
    Certification[Certification["Certification_90"] = 90] = "Certification_90";
    Certification[Certification["Certification_91"] = 91] = "Certification_91";
    Certification[Certification["Certification_92"] = 92] = "Certification_92";
    Certification[Certification["Certification_93"] = 93] = "Certification_93";
    Certification[Certification["Certification_94"] = 94] = "Certification_94";
    Certification[Certification["Certification_95"] = 95] = "Certification_95";
    Certification[Certification["Certification_96"] = 96] = "Certification_96";
    Certification[Certification["Certification_97"] = 97] = "Certification_97";
    Certification[Certification["Certification_98"] = 98] = "Certification_98";
    Certification[Certification["Certification_99"] = 99] = "Certification_99";
    Certification[Certification["Certification_100"] = 100] = "Certification_100";
    Certification[Certification["Certification_101"] = 101] = "Certification_101";
    Certification[Certification["Certification_102"] = 102] = "Certification_102";
    Certification[Certification["Certification_103"] = 103] = "Certification_103";
    Certification[Certification["Certification_104"] = 104] = "Certification_104";
    Certification[Certification["Certification_105"] = 105] = "Certification_105";
    Certification[Certification["Certification_106"] = 106] = "Certification_106";
    Certification[Certification["Certification_107"] = 107] = "Certification_107";
    Certification[Certification["Certification_108"] = 108] = "Certification_108";
    Certification[Certification["Certification_109"] = 109] = "Certification_109";
    Certification[Certification["Certification_110"] = 110] = "Certification_110";
    Certification[Certification["Certification_111"] = 111] = "Certification_111";
    Certification[Certification["Certification_112"] = 112] = "Certification_112";
    Certification[Certification["Certification_113"] = 113] = "Certification_113";
    Certification[Certification["Certification_114"] = 114] = "Certification_114";
    Certification[Certification["Certification_115"] = 115] = "Certification_115";
    Certification[Certification["Certification_116"] = 116] = "Certification_116";
    Certification[Certification["Certification_117"] = 117] = "Certification_117";
    Certification[Certification["Certification_118"] = 118] = "Certification_118";
    Certification[Certification["Certification_119"] = 119] = "Certification_119";
    Certification[Certification["Certification_120"] = 120] = "Certification_120";
    Certification[Certification["Certification_121"] = 121] = "Certification_121";
    Certification[Certification["Certification_122"] = 122] = "Certification_122";
    Certification[Certification["Certification_123"] = 123] = "Certification_123";
    Certification[Certification["Certification_124"] = 124] = "Certification_124";
    Certification[Certification["Certification_125"] = 125] = "Certification_125";
    Certification[Certification["Certification_126"] = 126] = "Certification_126";
    Certification[Certification["Certification_127"] = 127] = "Certification_127";
    Certification[Certification["Certification_128"] = 128] = "Certification_128";
    Certification[Certification["Certification_129"] = 129] = "Certification_129";
    Certification[Certification["Certification_130"] = 130] = "Certification_130";
    Certification[Certification["Certification_131"] = 131] = "Certification_131";
    Certification[Certification["Certification_132"] = 132] = "Certification_132";
    Certification[Certification["Certification_133"] = 133] = "Certification_133";
    Certification[Certification["Certification_134"] = 134] = "Certification_134";
    Certification[Certification["Certification_135"] = 135] = "Certification_135";
    Certification[Certification["Certification_136"] = 136] = "Certification_136";
    Certification[Certification["Certification_137"] = 137] = "Certification_137";
    Certification[Certification["Certification_138"] = 138] = "Certification_138";
    Certification[Certification["Certification_139"] = 139] = "Certification_139";
    Certification[Certification["Certification_140"] = 140] = "Certification_140";
    Certification[Certification["Certification_141"] = 141] = "Certification_141";
    Certification[Certification["Certification_142"] = 142] = "Certification_142";
    Certification[Certification["Certification_143"] = 143] = "Certification_143";
    Certification[Certification["Certification_144"] = 144] = "Certification_144";
    Certification[Certification["Certification_145"] = 145] = "Certification_145";
    Certification[Certification["Certification_146"] = 146] = "Certification_146";
    Certification[Certification["Certification_147"] = 147] = "Certification_147";
    Certification[Certification["Certification_148"] = 148] = "Certification_148";
    Certification[Certification["Certification_149"] = 149] = "Certification_149";
    Certification[Certification["Certification_150"] = 150] = "Certification_150";
    Certification[Certification["Certification_151"] = 151] = "Certification_151";
    Certification[Certification["Certification_152"] = 152] = "Certification_152";
    Certification[Certification["Certification_153"] = 153] = "Certification_153";
    Certification[Certification["Certification_154"] = 154] = "Certification_154";
    Certification[Certification["Certification_155"] = 155] = "Certification_155";
    Certification[Certification["Certification_156"] = 156] = "Certification_156";
    Certification[Certification["Certification_157"] = 157] = "Certification_157";
    Certification[Certification["Certification_158"] = 158] = "Certification_158";
    Certification[Certification["Certification_159"] = 159] = "Certification_159";
    Certification[Certification["Certification_160"] = 160] = "Certification_160";
    Certification[Certification["Certification_161"] = 161] = "Certification_161";
    Certification[Certification["Certification_162"] = 162] = "Certification_162";
    Certification[Certification["Certification_163"] = 163] = "Certification_163";
    Certification[Certification["Certification_164"] = 164] = "Certification_164";
    Certification[Certification["Certification_165"] = 165] = "Certification_165";
    Certification[Certification["Certification_166"] = 166] = "Certification_166";
    Certification[Certification["Certification_167"] = 167] = "Certification_167";
    Certification[Certification["Certification_168"] = 168] = "Certification_168";
    Certification[Certification["Certification_169"] = 169] = "Certification_169";
    Certification[Certification["Certification_170"] = 170] = "Certification_170";
    Certification[Certification["Certification_171"] = 171] = "Certification_171";
    Certification[Certification["Certification_172"] = 172] = "Certification_172";
    Certification[Certification["Certification_173"] = 173] = "Certification_173";
})(Certification || (Certification = {}));
//建築
export const CertificationList_1 = [
    { key: Certification.Certification_1, value: '一級建築士' },
    { key: Certification.Certification_2, value: '二級建築士' },
    { key: Certification.Certification_3, value: '2級建設機械整備' },
    { key: Certification.Certification_4, value: '1級建築施工管理技士' },
    { key: Certification.Certification_5, value: '2級建築施工管理技士' },
    { key: Certification.Certification_6, value: '木造建築士' },
    { key: Certification.Certification_7, value: '1級建築大工' },
    { key: Certification.Certification_8, value: '2級建築大工' },
    { key: Certification.Certification_9, value: '組壁建築' },
    { key: Certification.Certification_10, value: '1級ブロック建築' },
    { key: Certification.Certification_11, value: '2級ブロック建築' },
];
//石材
export const CertificationList_2 = [
    { key: Certification.Certification_12, value: '1級石工·石材·石積水' },
    { key: Certification.Certification_13, value: '2級石工·石材·石積水' },
];
//衛生
export const CertificationList_3 = [
    { key: Certification.Certification_14, value: '第1種衛生管理者' },
    { key: Certification.Certification_15, value: '第2種衛生管理者' },
];
//左官
export const CertificationList_4 = [
    { key: Certification.Certification_16, value: '1級左官' },
    { key: Certification.Certification_17, value: '2級左官' },
];
//建設機械
export const CertificationList_5 = [
    { key: Certification.Certification_18, value: '1級建設機械施工技士' },
    { key: Certification.Certification_19, value: '2級建設機械施工技士' },
    { key: Certification.Certification_20, value: '特級建設機械整備' },
    { key: Certification.Certification_21, value: '1級建設機械整備' },
];
//土木
export const CertificationList_6 = [
    { key: Certification.Certification_22, value: '1級土木施工管理技士' },
    { key: Certification.Certification_23, value: '2級土木施工管理技士' },
];
//測量
export const CertificationList_7 = [
    { key: Certification.Certification_24, value: '測量士' },
    { key: Certification.Certification_25, value: '測量士補' },
];
//下水道
export const CertificationList_8 = [
    { key: Certification.Certification_26, value: '第1種下水道技術者' },
    { key: Certification.Certification_27, value: '第2種下水道技術者' },
    { key: Certification.Certification_28, value: '第3種下水道技術者' },
];
//配管
export const CertificationList_9 = [
    { key: Certification.Certification_29, value: '1級管工事施工管理技士' },
    { key: Certification.Certification_30, value: '2級管工事施工管理技士' },
    { key: Certification.Certification_31, value: '1級配管(建築)' },
    { key: Certification.Certification_32, value: '2級配管(建築)' },
    { key: Certification.Certification_33, value: '3級配管(建築)' },
    { key: Certification.Certification_34, value: '1級配管(プラント)' },
    { key: Certification.Certification_35, value: '2級配管(プラント)' },
    { key: Certification.Certification_36, value: '3級配管(プラント)' },
];
//タイル
export const CertificationList_10 = [
    { key: Certification.Certification_37, value: '1級タイル張り' },
    { key: Certification.Certification_38, value: '2級タイル張り' },
];
//築炉
export const CertificationList_11 = [
    { key: Certification.Certification_39, value: '1級築炉' },
    { key: Certification.Certification_40, value: '2級築炉' },
];
//パネル
export const CertificationList_12 = [
    { key: Certification.Certification_41, value: 'エーエルシーパネル施工' },
];
//電気
export const CertificationList_13 = [
    { key: Certification.Certification_42, value: '1級電気工事施工技士' },
    { key: Certification.Certification_43, value: '2級電気工事施工技士' },
];
//造園
export const CertificationList_14 = [
    { key: Certification.Certification_44, value: '1級造園施工管理技士' },
    { key: Certification.Certification_45, value: '2級造園施工管理技士' },
];
//安全衛生
export const CertificationList_15 = [
    { key: Certification.Certification_46, value: '高庄室内作業主任者' },
    { key: Certification.Certification_47, value: 'エックス線作業主任者' },
    { key: Certification.Certification_48, value: '発破技士' },
    { key: Certification.Certification_49, value: '揚貨装置運転士' },
    { key: Certification.Certification_50, value: '特別ボイラー溶接士' },
    { key: Certification.Certification_51, value: '普通ボイラー溶接士' },
    { key: Certification.Certification_52, value: 'ボイラー整備士' },
    { key: Certification.Certification_53, value: '特級ボイラー技士' },
    { key: Certification.Certification_54, value: '一級ボイラー技士' },
    { key: Certification.Certification_55, value: '二級ボイラー技士' },
    { key: Certification.Certification_56, value: 'クレーン・デリック運転士' },
    { key: Certification.Certification_57, value: '移動式クレーン運転士' },
    { key: Certification.Certification_58, value: '潜水士' },
    { key: Certification.Certification_59, value: '潜水技士' },
    { key: Certification.Certification_60, value: '第1種作業環境測量士' },
    { key: Certification.Certification_61, value: '第2種作業環境測量士' },
];
//危険物
export const CertificationList_16 = [
    { key: Certification.Certification_62, value: 'ガンマ線写真撮影作業主任者' },
];
//海洋
export const CertificationList_17 = [
    { key: Certification.Certification_63, value: '海洋調查士' },
];
//ガス
export const CertificationList_18 = [
    { key: Certification.Certification_64, value: 'ガス溶接作業主任者' },
];
//林業
export const CertificationList_19 = [
    { key: Certification.Certification_65, value: '林業架線作業主任者' },
];
//ボイラー・タービン
export const CertificationList_20 = [
    { key: Certification.Certification_66, value: '第1種ボイラー・タービン主任技術者' },
    { key: Certification.Certification_67, value: '第2種ボイラー・タービン主任技術者' },
];
//とび
export const CertificationList_21 = [
    { key: Certification.Certification_68, value: '1級とび' },
    { key: Certification.Certification_69, value: '2級とび' },
    { key: Certification.Certification_70, value: '3級とび' },
];
//鉄鋼
export const CertificationList_22 = [
    { key: Certification.Certification_71, value: '1級鉄工' },
    { key: Certification.Certification_72, value: '2級鉄工' },
    { key: Certification.Certification_73, value: '1級鉄筋' },
    { key: Certification.Certification_74, value: '2級鉄筋' },
];
//板金
export const CertificationList_23 = [
    { key: Certification.Certification_75, value: '特級工場板金' },
    { key: Certification.Certification_76, value: '1級工場板金' },
    { key: Certification.Certification_77, value: '2級工場板金' },
    { key: Certification.Certification_78, value: '1級建築板金(内外装板金作業)' },
    { key: Certification.Certification_79, value: '2級建築板金(内外装板金作業)' },
    { key: Certification.Certification_80, value: '3級建築板金(内外装板金作業)' },
    { key: Certification.Certification_81, value: '1級建築板金(ダクト板金作業)' },
    { key: Certification.Certification_82, value: '2級建築板金(ダクト板金作業)' },
];
//屋根
export const CertificationList_24 = [
    { key: Certification.Certification_83, value: '1級かわらぶき' },
    { key: Certification.Certification_84, value: '2級かわらぶき' },
];
//ガラス
export const CertificationList_25 = [
    { key: Certification.Certification_85, value: '1級ガラス施工' },
    { key: Certification.Certification_86, value: '2級ガラス施工' },
];
//塗装
export const CertificationList_26 = [
    { key: Certification.Certification_87, value: '1級建築塗装' },
    { key: Certification.Certification_88, value: '2級建築塗装' },
    { key: Certification.Certification_89, value: '1級金属塗装' },
    { key: Certification.Certification_90, value: '2級金属塗装' },
    { key: Certification.Certification_91, value: '1級噴霧塗装' },
    { key: Certification.Certification_92, value: '2級噴霧塗装' },
    { key: Certification.Certification_93, value: '1級鋼橋塗装' },
];
//教育
export const CertificationList_27 = [
    { key: Certification.Certification_94, value: '職長' },
    { key: Certification.Certification_171, value: '職長・安全衛生責任者' },
];
//建設業労働災害
export const CertificationList_28 = [
    { key: Certification.Certification_95, value: 'ずい道等' },
    { key: Certification.Certification_96, value: '酸素欠乏危険作業' },
];
//建設機器
export const CertificationList_29 = [
    { key: Certification.Certification_97, value: 'ジャッキ式つり上げ' },
    { key: Certification.Certification_98, value: '建設用リフト' },
    { key: Certification.Certification_99, value: '巻上げ機' },
    { key: Certification.Certification_100, value: '研削といし' },
    { key: Certification.Certification_101, value: '伐木等機械' },
    { key: Certification.Certification_102, value: '走行集材機械' },
    { key: Certification.Certification_103, value: '機械集材装置' },
    { key: Certification.Certification_104, value: '簡易架線集材装置' },
    { key: Certification.Certification_105, value: 'チェーンソー伐木 動力プレス' },
    { key: Certification.Certification_106, value: 'ゴンドラ' },
];
//建設作業
export const CertificationList_30 = [
    { key: Certification.Certification_107, value: '粉じん' },
    { key: Certification.Certification_108, value: '足場組立' },
    { key: Certification.Certification_109, value: 'ロープ高所作業' },
];
//車両
export const CertificationList_31 = [
    { key: Certification.Certification_110, value: 'フォークリフト' },
    { key: Certification.Certification_111, value: '不整地運搬車' },
    { key: Certification.Certification_112, value: '高所作業車' },
    { key: Certification.Certification_113, value: 'ショベルローダー等' },
    { key: Certification.Certification_114, value: '小型車両系(解体)' },
    { key: Certification.Certification_115, value: '小型車両系(整地等)' },
    { key: Certification.Certification_116, value: '小型車両系(基礎工事)' },
    { key: Certification.Certification_117, value: '車両系(基礎工事)' },
    { key: Certification.Certification_118, value: '車両系(コンクリート打設)' },
    { key: Certification.Certification_119, value: 'クレーン' },
    { key: Certification.Certification_120, value: 'デリック 移動式クレーン' },
    { key: Certification.Certification_121, value: '玉掛' },
    { key: Certification.Certification_122, value: '軌道装置動力車' },
    { key: Certification.Certification_123, value: 'ローラー' },
    { key: Certification.Certification_124, value: 'タイヤ空気充てん' },
];
//船舶
export const CertificationList_32 = [
    { key: Certification.Certification_125, value: '揚貨装置' },
];
//ボイラー
export const CertificationList_33 = [
    { key: Certification.Certification_126, value: '小型ボイラー' },
];
//ボーリング
export const CertificationList_34 = [
    { key: Certification.Certification_127, value: 'ボーリングマシン' },
];
//溶接
export const CertificationList_35 = [
    { key: Certification.Certification_128, value: 'アーク溶接' },
];
//電気
export const CertificationList_36 = [
    { key: Certification.Certification_129, value: '電気取扱(高圧・特別高圧)' },
    { key: Certification.Certification_130, value: '電気取扱(低圧)' },
];
//科学
export const CertificationList_37 = [
    { key: Certification.Certification_131, value: '特殊化学設備' },
    { key: Certification.Certification_132, value: '四アルキル鉛等' },
];
//ロボット
export const CertificationList_38 = [
    { key: Certification.Certification_133, value: '産業用ロボット(教示)' },
    { key: Certification.Certification_134, value: '産業用ロボット(検査)' },
];
//危険物
export const CertificationList_39 = [
    { key: Certification.Certification_135, value: 'エックス線装置又はガンマ線照射装置' },
];
//空気
export const CertificationList_40 = [
    { key: Certification.Certification_136, value: '空気圧縮機' },
    { key: Certification.Certification_137, value: '高圧室内作業' },
    { key: Certification.Certification_138, value: '氛聞室' },
    { key: Certification.Certification_139, value: '潜水作業者への送気' },
    { key: Certification.Certification_140, value: '再圧室' },
];
//核燃料
export const CertificationList_41 = [
    { key: Certification.Certification_141, value: '核燃料物質(加工施設等)' },
    { key: Certification.Certification_142, value: '核燃料物質(原子炉施設等)' },
];
//廃棄物
export const CertificationList_42 = [
    { key: Certification.Certification_143, value: '廃棄物焼却(ダイオキシン類)' },
    { key: Certification.Certification_144, value: '石綿' },
    { key: Certification.Certification_145, value: '除染等' },
];
//木材機械
export const CertificationList_43 = [
    { key: Certification.Certification_146, value: '木材加工用機械' },
];
//機械
export const CertificationList_44 = [
    { key: Certification.Certification_147, value: 'プレス機械' },
];
//設備
export const CertificationList_45 = [
    { key: Certification.Certification_148, value: '乾燥設備' },
];
//建設機械
export const CertificationList_46 = [
    { key: Certification.Certification_149, value: 'コンクリート破砕器' },
];
//車両
export const CertificationList_47 = [
    { key: Certification.Certification_150, value: '足場組立て' },
    { key: Certification.Certification_151, value: 'はい作業' },
    { key: Certification.Certification_152, value: 'フォークリフト' },
    { key: Certification.Certification_153, value: '不整地運搬車' },
    { key: Certification.Certification_154, value: '高所作業車' },
    { key: Certification.Certification_155, value: 'ショベルローダー' },
    { key: Certification.Certification_156, value: '小型移動式クレーン' },
    { key: Certification.Certification_157, value: '床上操作式クレーン' },
    { key: Certification.Certification_158, value: '車両系(解体用)' },
    { key: Certification.Certification_159, value: '車両系(基礎工事)' },
    { key: Certification.Certification_160, value: '車両系(整地)' },
    { key: Certification.Certification_161, value: '玉掛け' },
];
//運転免許証
export const CertificationList_48 = [
    { key: Certification.Certification_162, value: '普通免許証' },
    { key: Certification.Certification_163, value: '準中型免許(5t未満限定)' },
    { key: Certification.Certification_164, value: '準中型免許' },
    { key: Certification.Certification_165, value: '中型免許証' },
    { key: Certification.Certification_166, value: '中型免許証(8t未満)' },
    { key: Certification.Certification_167, value: '大型免許証' },
];
//技能講習その他
export const CertificationList_49 = [
    { key: Certification.Certification_168, value: '足場組立主任者' },
    { key: Certification.Certification_169, value: '酸欠主任者' },
    { key: Certification.Certification_170, value: '酸欠・硫化水素主任者' },
];
//溶接
export const CertificationList_50 = [
    { key: Certification.Certification_172, value: '半自動溶接' },
    { key: Certification.Certification_173, value: '手溶接' },
];
export const CertificationList = [
    ...CertificationList_1,
    ...CertificationList_2,
    ...CertificationList_3,
    ...CertificationList_4,
    ...CertificationList_5,
    ...CertificationList_6,
    ...CertificationList_7,
    ...CertificationList_8,
    ...CertificationList_9,
    ...CertificationList_10,
    ...CertificationList_11,
    ...CertificationList_12,
    ...CertificationList_13,
    ...CertificationList_14,
    ...CertificationList_15,
    ...CertificationList_16,
    ...CertificationList_17,
    ...CertificationList_18,
    ...CertificationList_19,
    ...CertificationList_20,
    ...CertificationList_21,
    ...CertificationList_22,
    ...CertificationList_23,
    ...CertificationList_24,
    ...CertificationList_25,
    ...CertificationList_26,
    ...CertificationList_27,
    ...CertificationList_28,
    ...CertificationList_29,
    ...CertificationList_30,
    ...CertificationList_31,
    ...CertificationList_32,
    ...CertificationList_33,
    ...CertificationList_34,
    ...CertificationList_35,
    ...CertificationList_36,
    ...CertificationList_37,
    ...CertificationList_38,
    ...CertificationList_39,
    ...CertificationList_40,
    ...CertificationList_41,
    ...CertificationList_42,
    ...CertificationList_43,
    ...CertificationList_44,
    ...CertificationList_45,
    ...CertificationList_46,
    ...CertificationList_47,
    ...CertificationList_48,
    ...CertificationList_49,
    ...CertificationList_50
];
//資格の中分類
export var CertificationCatergoryEnum;
(function (CertificationCatergoryEnum) {
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_1"] = 1] = "Certification_1";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_2"] = 2] = "Certification_2";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_3"] = 3] = "Certification_3";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_4"] = 4] = "Certification_4";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_5"] = 5] = "Certification_5";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_6"] = 6] = "Certification_6";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_7"] = 7] = "Certification_7";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_8"] = 8] = "Certification_8";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_9"] = 9] = "Certification_9";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_10"] = 10] = "Certification_10";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_11"] = 11] = "Certification_11";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_12"] = 12] = "Certification_12";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_13"] = 13] = "Certification_13";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_14"] = 14] = "Certification_14";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_15"] = 15] = "Certification_15";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_16"] = 16] = "Certification_16";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_17"] = 17] = "Certification_17";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_18"] = 18] = "Certification_18";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_19"] = 19] = "Certification_19";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_20"] = 20] = "Certification_20";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_21"] = 21] = "Certification_21";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_22"] = 22] = "Certification_22";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_23"] = 23] = "Certification_23";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_24"] = 24] = "Certification_24";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_25"] = 25] = "Certification_25";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_26"] = 26] = "Certification_26";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_27"] = 27] = "Certification_27";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_28"] = 28] = "Certification_28";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_29"] = 29] = "Certification_29";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_30"] = 30] = "Certification_30";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_31"] = 31] = "Certification_31";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_32"] = 32] = "Certification_32";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_33"] = 33] = "Certification_33";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_34"] = 34] = "Certification_34";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_35"] = 35] = "Certification_35";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_36"] = 36] = "Certification_36";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_37"] = 37] = "Certification_37";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_38"] = 38] = "Certification_38";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_39"] = 39] = "Certification_39";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_40"] = 40] = "Certification_40";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_41"] = 41] = "Certification_41";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_42"] = 42] = "Certification_42";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_43"] = 43] = "Certification_43";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_44"] = 44] = "Certification_44";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_45"] = 45] = "Certification_45";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_46"] = 46] = "Certification_46";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_47"] = 47] = "Certification_47";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_48"] = 48] = "Certification_48";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_49"] = 49] = "Certification_49";
    CertificationCatergoryEnum[CertificationCatergoryEnum["Certification_50"] = 50] = "Certification_50";
})(CertificationCatergoryEnum || (CertificationCatergoryEnum = {}));
//大項目-資格
export const CertificationCategoryList1 = [
    { key: CertificationCatergoryEnum.Certification_1, value: "建築", list: CertificationList_1 },
    { key: CertificationCatergoryEnum.Certification_2, value: "石材", list: CertificationList_2 },
    { key: CertificationCatergoryEnum.Certification_3, value: "衛生", list: CertificationList_3 },
    { key: CertificationCatergoryEnum.Certification_4, value: "左官", list: CertificationList_4 },
    { key: CertificationCatergoryEnum.Certification_5, value: "建設機械", list: CertificationList_5 },
    { key: CertificationCatergoryEnum.Certification_6, value: "土木", list: CertificationList_6 },
    { key: CertificationCatergoryEnum.Certification_7, value: "測量", list: CertificationList_7 },
    { key: CertificationCatergoryEnum.Certification_8, value: "下水道", list: CertificationList_8 },
    { key: CertificationCatergoryEnum.Certification_9, value: "配管", list: CertificationList_9 },
    { key: CertificationCatergoryEnum.Certification_10, value: "タイル", list: CertificationList_10 },
    { key: CertificationCatergoryEnum.Certification_11, value: "築炉", list: CertificationList_11 },
    { key: CertificationCatergoryEnum.Certification_12, value: "パネル", list: CertificationList_12 },
    { key: CertificationCatergoryEnum.Certification_13, value: "電気", list: CertificationList_13 },
    { key: CertificationCatergoryEnum.Certification_14, value: "造園", list: CertificationList_14 },
    { key: CertificationCatergoryEnum.Certification_15, value: "安全衛生", list: CertificationList_15 },
    { key: CertificationCatergoryEnum.Certification_16, value: "危険物", list: CertificationList_16 },
    { key: CertificationCatergoryEnum.Certification_17, value: "海洋", list: CertificationList_17 },
    { key: CertificationCatergoryEnum.Certification_18, value: "ガス", list: CertificationList_18 },
    { key: CertificationCatergoryEnum.Certification_19, value: "林業", list: CertificationList_19 },
    { key: CertificationCatergoryEnum.Certification_20, value: "ボイラー・タービン", list: CertificationList_20 },
    { key: CertificationCatergoryEnum.Certification_21, value: "とび", list: CertificationList_21 },
    { key: CertificationCatergoryEnum.Certification_22, value: "鉄鋼", list: CertificationList_22 },
    { key: CertificationCatergoryEnum.Certification_23, value: "板金", list: CertificationList_23 },
    { key: CertificationCatergoryEnum.Certification_24, value: "屋根", list: CertificationList_24 },
    { key: CertificationCatergoryEnum.Certification_25, value: "ガラス", list: CertificationList_25 },
    { key: CertificationCatergoryEnum.Certification_26, value: "塗装", list: CertificationList_26 },
    { key: CertificationCatergoryEnum.Certification_48, value: "運転免許証", list: CertificationList_48 },
    { key: CertificationCatergoryEnum.Certification_50, value: "溶接", list: CertificationList_50 },
];
export const CertificationCategoryAllList1 = [
    ...CertificationList_1,
    ...CertificationList_2,
    ...CertificationList_3,
    ...CertificationList_4,
    ...CertificationList_5,
    ...CertificationList_6,
    ...CertificationList_7,
    ...CertificationList_8,
    ...CertificationList_9,
    ...CertificationList_10,
    ...CertificationList_11,
    ...CertificationList_12,
    ...CertificationList_13,
    ...CertificationList_14,
    ...CertificationList_15,
    ...CertificationList_16,
    ...CertificationList_17,
    ...CertificationList_18,
    ...CertificationList_19,
    ...CertificationList_20,
    ...CertificationList_21,
    ...CertificationList_22,
    ...CertificationList_23,
    ...CertificationList_24,
    ...CertificationList_25,
    ...CertificationList_26,
    ...CertificationList_48,
    ...CertificationList_50
];
//大項目-特別教育
export const CertificationCategoryList2 = [
    { key: CertificationCatergoryEnum.Certification_27, value: "教育", list: CertificationList_27 },
    { key: CertificationCatergoryEnum.Certification_28, value: "建設業労働災害", list: CertificationList_28 },
    { key: CertificationCatergoryEnum.Certification_29, value: "建設機器", list: CertificationList_29 },
    { key: CertificationCatergoryEnum.Certification_30, value: "建設作業", list: CertificationList_30 },
    { key: CertificationCatergoryEnum.Certification_31, value: "車両", list: CertificationList_31 },
    { key: CertificationCatergoryEnum.Certification_32, value: "船舶", list: CertificationList_32 },
    { key: CertificationCatergoryEnum.Certification_33, value: "ボイラー", list: CertificationList_33 },
    { key: CertificationCatergoryEnum.Certification_34, value: "ボーリング", list: CertificationList_34 },
    { key: CertificationCatergoryEnum.Certification_35, value: "溶接", list: CertificationList_35 },
    { key: CertificationCatergoryEnum.Certification_36, value: "電気", list: CertificationList_36 },
    { key: CertificationCatergoryEnum.Certification_37, value: "科学", list: CertificationList_37 },
    { key: CertificationCatergoryEnum.Certification_38, value: "ロボット", list: CertificationList_38 },
    { key: CertificationCatergoryEnum.Certification_39, value: "危険物", list: CertificationList_39 },
    { key: CertificationCatergoryEnum.Certification_40, value: "空気", list: CertificationList_40 },
    { key: CertificationCatergoryEnum.Certification_41, value: "核燃料", list: CertificationList_41 },
    { key: CertificationCatergoryEnum.Certification_42, value: "廃棄物", list: CertificationList_42 },
];
export const CertificationCategoryAllList2 = [
    ...CertificationList_27,
    ...CertificationList_28,
    ...CertificationList_29,
    ...CertificationList_30,
    ...CertificationList_31,
    ...CertificationList_32,
    ...CertificationList_33,
    ...CertificationList_34,
    ...CertificationList_35,
    ...CertificationList_36,
    ...CertificationList_37,
    ...CertificationList_38,
    ...CertificationList_39,
    ...CertificationList_40,
    ...CertificationList_41,
    ...CertificationList_42,
];
//大項目-特別教育
export const CertificationCategoryList3 = [
    { key: CertificationCatergoryEnum.Certification_43, value: "木材機械", list: CertificationList_43 },
    { key: CertificationCatergoryEnum.Certification_44, value: "機械", list: CertificationList_44 },
    { key: CertificationCatergoryEnum.Certification_45, value: "設備", list: CertificationList_45 },
    { key: CertificationCatergoryEnum.Certification_46, value: "建設機械", list: CertificationList_46 },
    { key: CertificationCatergoryEnum.Certification_47, value: "車両", list: CertificationList_47 },
    { key: CertificationCatergoryEnum.Certification_49, value: "その他", list: CertificationList_49 },
];
export const CertificationCategoryAllList3 = [
    ...CertificationList_43,
    ...CertificationList_44,
    ...CertificationList_45,
    ...CertificationList_46,
    ...CertificationList_47,
    ...CertificationList_49,
];
//退会部分のリスト
export var WithdrawalEnum;
(function (WithdrawalEnum) {
    WithdrawalEnum[WithdrawalEnum["UnWithdrawal"] = 1] = "UnWithdrawal";
    WithdrawalEnum[WithdrawalEnum["Withdrawal"] = 2] = "Withdrawal";
})(WithdrawalEnum || (WithdrawalEnum = {}));
export const WithdrawalList = [
    { key: WithdrawalEnum.UnWithdrawal, value: '未退会' },
    { key: WithdrawalEnum.Withdrawal, value: '退会済み' },
];
export var ExamTypeEnum;
(function (ExamTypeEnum) {
    ExamTypeEnum[ExamTypeEnum["Plumbing"] = 1] = "Plumbing";
})(ExamTypeEnum || (ExamTypeEnum = {}));
export const ExamTypeList = [
    { key: ExamTypeEnum.Plumbing, value: '配管工' },
];
// 業種
export var Industry;
(function (Industry) {
    Industry[Industry["_1"] = 1] = "_1";
    Industry[Industry["_2"] = 2] = "_2";
    Industry[Industry["_3"] = 3] = "_3";
    Industry[Industry["_4"] = 4] = "_4";
    Industry[Industry["_5"] = 5] = "_5";
    Industry[Industry["_6"] = 6] = "_6";
    Industry[Industry["_7"] = 7] = "_7";
    Industry[Industry["_8"] = 8] = "_8";
    Industry[Industry["_9"] = 9] = "_9";
    Industry[Industry["_10"] = 10] = "_10";
    Industry[Industry["_11"] = 11] = "_11";
    Industry[Industry["_12"] = 12] = "_12";
    Industry[Industry["_13"] = 13] = "_13";
    Industry[Industry["_14"] = 14] = "_14";
    Industry[Industry["_15"] = 15] = "_15";
    Industry[Industry["_16"] = 16] = "_16";
    Industry[Industry["_17"] = 17] = "_17";
    Industry[Industry["_18"] = 18] = "_18";
    Industry[Industry["_19"] = 19] = "_19";
    Industry[Industry["_20"] = 20] = "_20";
    Industry[Industry["_21"] = 21] = "_21";
    Industry[Industry["_22"] = 22] = "_22";
    Industry[Industry["_23"] = 23] = "_23";
    Industry[Industry["_24"] = 24] = "_24";
    Industry[Industry["_25"] = 25] = "_25";
    Industry[Industry["_26"] = 26] = "_26";
    Industry[Industry["_27"] = 27] = "_27";
    Industry[Industry["_28"] = 28] = "_28";
    Industry[Industry["_29"] = 29] = "_29";
    Industry[Industry["_30"] = 30] = "_30";
    Industry[Industry["_31"] = 31] = "_31";
    Industry[Industry["_32"] = 32] = "_32";
    Industry[Industry["_33"] = 33] = "_33";
    Industry[Industry["_34"] = 34] = "_34";
    Industry[Industry["_35"] = 35] = "_35";
    Industry[Industry["_36"] = 36] = "_36";
    Industry[Industry["_37"] = 37] = "_37";
    Industry[Industry["_38"] = 38] = "_38";
    Industry[Industry["_39"] = 39] = "_39";
    Industry[Industry["_40"] = 40] = "_40";
    Industry[Industry["_41"] = 41] = "_41";
    Industry[Industry["_42"] = 42] = "_42";
    Industry[Industry["_43"] = 43] = "_43";
    Industry[Industry["_44"] = 44] = "_44";
    Industry[Industry["_45"] = 45] = "_45";
    Industry[Industry["_46"] = 46] = "_46";
    Industry[Industry["_47"] = 47] = "_47";
    Industry[Industry["_48"] = 48] = "_48";
    Industry[Industry["_49"] = 49] = "_49";
    Industry[Industry["_50"] = 50] = "_50";
    Industry[Industry["_51"] = 51] = "_51";
    Industry[Industry["_52"] = 52] = "_52";
    Industry[Industry["_53"] = 53] = "_53";
    Industry[Industry["_54"] = 54] = "_54";
    Industry[Industry["_55"] = 55] = "_55";
    Industry[Industry["_56"] = 56] = "_56";
    Industry[Industry["_57"] = 57] = "_57";
    Industry[Industry["_58"] = 58] = "_58";
    Industry[Industry["_59"] = 59] = "_59";
    Industry[Industry["_60"] = 60] = "_60";
    Industry[Industry["_61"] = 61] = "_61";
    Industry[Industry["_62"] = 62] = "_62";
    Industry[Industry["_63"] = 63] = "_63";
    Industry[Industry["_64"] = 64] = "_64";
    Industry[Industry["_65"] = 65] = "_65";
    Industry[Industry["_66"] = 66] = "_66";
    Industry[Industry["_67"] = 67] = "_67";
    Industry[Industry["_68"] = 68] = "_68";
    Industry[Industry["_69"] = 69] = "_69";
    Industry[Industry["_70"] = 70] = "_70";
    Industry[Industry["_71"] = 71] = "_71";
    Industry[Industry["_72"] = 72] = "_72";
    Industry[Industry["_73"] = 73] = "_73";
    Industry[Industry["_74"] = 74] = "_74";
    Industry[Industry["_75"] = 75] = "_75";
    Industry[Industry["_76"] = 76] = "_76";
    Industry[Industry["_77"] = 77] = "_77";
    Industry[Industry["_78"] = 78] = "_78";
    Industry[Industry["_79"] = 79] = "_79";
    Industry[Industry["_80"] = 80] = "_80";
    Industry[Industry["_81"] = 81] = "_81";
    Industry[Industry["_82"] = 82] = "_82";
    Industry[Industry["_83"] = 83] = "_83";
    Industry[Industry["_84"] = 84] = "_84";
    Industry[Industry["_85"] = 85] = "_85";
    Industry[Industry["_86"] = 86] = "_86";
    Industry[Industry["_87"] = 87] = "_87";
    Industry[Industry["_88"] = 88] = "_88";
    Industry[Industry["_89"] = 89] = "_89";
    Industry[Industry["_90"] = 90] = "_90";
    Industry[Industry["_91"] = 91] = "_91";
    Industry[Industry["_92"] = 92] = "_92";
    Industry[Industry["_93"] = 93] = "_93";
    Industry[Industry["_94"] = 94] = "_94";
    Industry[Industry["_95"] = 95] = "_95";
    Industry[Industry["_96"] = 96] = "_96";
    Industry[Industry["_97"] = 97] = "_97";
    Industry[Industry["_98"] = 98] = "_98";
    Industry[Industry["_99"] = 99] = "_99";
    Industry[Industry["_100"] = 100] = "_100";
    Industry[Industry["_101"] = 101] = "_101";
    Industry[Industry["_102"] = 102] = "_102";
    Industry[Industry["_103"] = 103] = "_103";
    Industry[Industry["_104"] = 104] = "_104";
    Industry[Industry["_105"] = 105] = "_105";
    Industry[Industry["_106"] = 106] = "_106";
    Industry[Industry["_107"] = 107] = "_107";
    Industry[Industry["_108"] = 108] = "_108";
    Industry[Industry["_109"] = 109] = "_109";
    Industry[Industry["_110"] = 110] = "_110";
    Industry[Industry["_111"] = 111] = "_111";
    Industry[Industry["_112"] = 112] = "_112";
    Industry[Industry["_113"] = 113] = "_113";
    Industry[Industry["_114"] = 114] = "_114";
    Industry[Industry["_115"] = 115] = "_115";
    Industry[Industry["_116"] = 116] = "_116";
    Industry[Industry["_117"] = 117] = "_117";
    Industry[Industry["_118"] = 118] = "_118";
    Industry[Industry["_119"] = 119] = "_119";
    Industry[Industry["_120"] = 120] = "_120";
    Industry[Industry["_121"] = 121] = "_121";
    Industry[Industry["_122"] = 122] = "_122";
    Industry[Industry["_123"] = 123] = "_123";
    Industry[Industry["_124"] = 124] = "_124";
    Industry[Industry["_125"] = 125] = "_125";
    Industry[Industry["_126"] = 126] = "_126";
    Industry[Industry["_127"] = 127] = "_127";
    Industry[Industry["_128"] = 128] = "_128";
    Industry[Industry["_129"] = 129] = "_129";
    Industry[Industry["_130"] = 130] = "_130";
    Industry[Industry["_131"] = 131] = "_131";
    Industry[Industry["_132"] = 132] = "_132";
    Industry[Industry["_133"] = 133] = "_133";
    Industry[Industry["_134"] = 134] = "_134";
    Industry[Industry["_135"] = 135] = "_135";
    Industry[Industry["_136"] = 136] = "_136";
    Industry[Industry["_137"] = 137] = "_137";
    Industry[Industry["_138"] = 138] = "_138";
    Industry[Industry["_139"] = 139] = "_139";
    Industry[Industry["_140"] = 140] = "_140";
    Industry[Industry["_141"] = 141] = "_141";
    Industry[Industry["_142"] = 142] = "_142";
    Industry[Industry["_143"] = 143] = "_143";
    Industry[Industry["_144"] = 144] = "_144";
    Industry[Industry["_145"] = 145] = "_145";
    Industry[Industry["_146"] = 146] = "_146";
    Industry[Industry["_147"] = 147] = "_147";
    Industry[Industry["_148"] = 148] = "_148";
    Industry[Industry["_149"] = 149] = "_149";
    Industry[Industry["_150"] = 150] = "_150";
    Industry[Industry["_151"] = 151] = "_151";
    Industry[Industry["_152"] = 152] = "_152";
    Industry[Industry["_153"] = 153] = "_153";
    Industry[Industry["_154"] = 154] = "_154";
    Industry[Industry["_155"] = 155] = "_155";
    Industry[Industry["_156"] = 156] = "_156";
    Industry[Industry["_157"] = 157] = "_157";
    Industry[Industry["_158"] = 158] = "_158";
    Industry[Industry["_159"] = 159] = "_159";
    Industry[Industry["_160"] = 160] = "_160";
    Industry[Industry["_161"] = 161] = "_161";
    Industry[Industry["_162"] = 162] = "_162";
    Industry[Industry["_163"] = 163] = "_163";
    Industry[Industry["_164"] = 164] = "_164";
    Industry[Industry["_165"] = 165] = "_165";
    Industry[Industry["_166"] = 166] = "_166";
    Industry[Industry["_167"] = 167] = "_167";
    Industry[Industry["_168"] = 168] = "_168";
    Industry[Industry["_169"] = 169] = "_169";
    Industry[Industry["_170"] = 170] = "_170";
    Industry[Industry["_171"] = 171] = "_171";
    Industry[Industry["_172"] = 172] = "_172";
    Industry[Industry["_173"] = 173] = "_173";
    Industry[Industry["_174"] = 174] = "_174";
    Industry[Industry["_175"] = 175] = "_175";
    Industry[Industry["_176"] = 176] = "_176";
    Industry[Industry["_177"] = 177] = "_177";
    Industry[Industry["_178"] = 178] = "_178";
    Industry[Industry["_179"] = 179] = "_179";
    Industry[Industry["_180"] = 180] = "_180";
    Industry[Industry["_181"] = 181] = "_181";
    Industry[Industry["_182"] = 182] = "_182";
    Industry[Industry["_183"] = 183] = "_183";
    Industry[Industry["_184"] = 184] = "_184";
    Industry[Industry["_185"] = 185] = "_185";
    Industry[Industry["_186"] = 186] = "_186";
    Industry[Industry["_187"] = 187] = "_187";
    Industry[Industry["_188"] = 188] = "_188";
    Industry[Industry["_189"] = 189] = "_189";
    Industry[Industry["_190"] = 190] = "_190";
    Industry[Industry["_191"] = 191] = "_191";
    Industry[Industry["_192"] = 192] = "_192";
    Industry[Industry["_193"] = 193] = "_193";
    Industry[Industry["_194"] = 194] = "_194";
    Industry[Industry["_195"] = 195] = "_195";
    Industry[Industry["_196"] = 196] = "_196";
    Industry[Industry["_197"] = 197] = "_197";
    Industry[Industry["_198"] = 198] = "_198";
    Industry[Industry["_199"] = 199] = "_199";
    Industry[Industry["_200"] = 200] = "_200";
    Industry[Industry["_201"] = 201] = "_201";
    Industry[Industry["_202"] = 202] = "_202";
    Industry[Industry["_203"] = 203] = "_203";
    Industry[Industry["_204"] = 204] = "_204";
    Industry[Industry["_205"] = 205] = "_205";
    Industry[Industry["_206"] = 206] = "_206";
    Industry[Industry["_207"] = 207] = "_207";
    Industry[Industry["_208"] = 208] = "_208";
    Industry[Industry["_OTHER"] = 9999] = "_OTHER";
})(Industry || (Industry = {}));
// 業種一覧
//管工事業
export const IndustryList_1 = [
    { key: Industry._1, value: '冷暖房設備工事・エアコン工事' },
    { key: Industry._2, value: '冷凍冷蔵設備工事' },
    { key: Industry._3, value: '空調設備工事' },
    { key: Industry._4, value: '給排水・給湯設備工事' },
    { key: Industry._5, value: '厨房設備工事' },
    { key: Industry._6, value: '衛生設備工事' },
    { key: Industry._7, value: '浄化槽工事' },
    { key: Industry._8, value: '水洗便所設備工事・トイレ工事' },
    { key: Industry._9, value: 'ガス管配管工事' },
    { key: Industry._10, value: 'ダクト工事' },
    { key: Industry._11, value: '管内更生工事' },
    { key: Industry._12, value: '燃料配管工事' },
    { key: Industry._13, value: 'その他管工事' },
    { key: Industry._14, value: '水道工事' },
    { key: Industry._15, value: 'サニタリー配管工事' },
    { key: Industry._208, value: 'プラント配管工事' },
];
//土木工事業
export const IndustryList_2 = [
    { key: Industry._16, value: '土木一式工事' },
    { key: Industry._17, value: '土木工事' },
    { key: Industry._18, value: '推進工事' },
    { key: Industry._19, value: '下水道工事' },
];
//建築工事業
export const IndustryList_3 = [
    { key: Industry._20, value: '建築一式工事' },
    { key: Industry._21, value: '住宅基礎工事' },
    { key: Industry._22, value: '建築工事' },
    { key: Industry._23, value: 'アスベスト撤去工事（躯体解体含む）' },
];
//大工工事業
export const IndustryList_4 = [
    { key: Industry._24, value: '大工工事' },
    { key: Industry._25, value: '型枠工事' },
    { key: Industry._26, value: '造作工事' },
    { key: Industry._27, value: '木工工事・木工事' },
    { key: Industry._28, value: '大工建方工事' },
    { key: Industry._29, value: 'サイディング工事（木質）' },
];
//左官工事業
export const IndustryList_5 = [
    { key: Industry._30, value: '左官工事' },
    { key: Industry._31, value: 'モルタル工事' },
    { key: Industry._32, value: 'モルタル防水工事' },
    { key: Industry._33, value: '吹付け工事' },
    { key: Industry._34, value: 'とぎ出し工事' },
    { key: Industry._35, value: '洗い出し工事' },
];
//とび・土工工事業
export const IndustryList_6 = [
    { key: Industry._36, value: 'とび工事・鳶工事' },
    { key: Industry._37, value: 'ひき工事' },
    { key: Industry._38, value: '足場等仮設工事' },
    { key: Industry._39, value: '重量物の揚重運搬配置工事' },
    { key: Industry._40, value: '鉄骨組立て工事・鉄骨建方工事' },
    { key: Industry._41, value: 'コンクリートブロック据付け工事' },
    { key: Industry._42, value: '杭打ち工事' },
    { key: Industry._43, value: '杭抜き工事' },
    { key: Industry._44, value: '場所打ち杭工事' },
    { key: Industry._45, value: '土工事・土工工事' },
    { key: Industry._46, value: '掘削工事' },
    { key: Industry._47, value: '根切り工事' },
    { key: Industry._48, value: '発破工事' },
    { key: Industry._49, value: '盛土工事' },
    { key: Industry._50, value: 'コンクリート打設工事' },
    { key: Industry._51, value: 'コンクリート圧送工事' },
    { key: Industry._52, value: 'プレストレストコンクリート工事' },
    { key: Industry._53, value: '地すべり防止工事' },
    { key: Industry._54, value: '地盤改良工事' },
    { key: Industry._55, value: 'ボーリンググラウト工事' },
    { key: Industry._56, value: '土留め（山留め）工事・擁壁工事' },
    { key: Industry._57, value: '仮締切り工事' },
    { key: Industry._58, value: '吹付け工事' },
    { key: Industry._59, value: '道路付属物設置工事' },
    { key: Industry._60, value: '捨石工事' },
    { key: Industry._61, value: '外構工事' },
    { key: Industry._62, value: 'はつり工事' },
    { key: Industry._63, value: '足場工事' },
    { key: Industry._64, value: '安全施設工事' },
    { key: Industry._65, value: 'アンカー工事' },
    { key: Industry._66, value: 'コンクリート切断・穿孔工事' },
];
//石工事業
export const IndustryList_7 = [
    { key: Industry._67, value: '石積み（張り）工事' },
    { key: Industry._68, value: 'コンクリートブロック積み（張り）工事・ブロック工事' },
    { key: Industry._69, value: '石工事・石工工事' },
    { key: Industry._70, value: '石タイル工事' },
];
//屋根工事業
export const IndustryList_8 = [
    { key: Industry._71, value: '屋根ふき工事' },
    { key: Industry._72, value: '屋根工事' },
    { key: Industry._73, value: '天窓工事' },
];
//電気工事業
export const IndustryList_9 = [
    { key: Industry._74, value: '発電設備工事' },
    { key: Industry._75, value: '送配電線工事' },
    { key: Industry._76, value: '引込線工事' },
    { key: Industry._77, value: '変電設備工事' },
    { key: Industry._78, value: '構内電気設備（非常用電気設備を含む。）工事' },
    { key: Industry._79, value: '照明設備工事・LED工事' },
    { key: Industry._80, value: '電車線工事' },
    { key: Industry._81, value: '信号設備工事' },
    { key: Industry._82, value: 'ネオン装置工事' },
    { key: Industry._83, value: 'その他電気工事' },
    { key: Industry._84, value: '太陽光発電工事・ソーラーパネル設置工事' },
    { key: Industry._85, value: '蓄電池工事' },
    { key: Industry._86, value: '幹線工事' },
    { key: Industry._87, value: '計装工事' },
    { key: Industry._88, value: '電気制御工事' },
];
//タイル、れんが、ブロック工事業
export const IndustryList_10 = [
    { key: Industry._89, value: 'コンクリートブロック積み（張り）工事・ブロック工事' },
    { key: Industry._90, value: 'レンガ積み（張り）工事・レンガ工事' },
    { key: Industry._91, value: 'タイル張り工事・タイル工事' },
    { key: Industry._92, value: '築炉工事' },
    { key: Industry._93, value: 'スレート張り工事' },
    { key: Industry._94, value: 'ALC工事' },
    { key: Industry._95, value: 'サイディング工事（窯業）' },
];
//鋼構造物工事業
export const IndustryList_11 = [
    { key: Industry._96, value: '鉄骨工事' },
    { key: Industry._97, value: '橋梁工事' },
    { key: Industry._98, value: '鉄塔工事' },
    { key: Industry._99, value: '貯蔵用タンク設置工事・製缶工事' },
    { key: Industry._100, value: '水門・閘門扉設置工事' },
    { key: Industry._101, value: '看板サイン工事' },
    { key: Industry._102, value: '鉄工工事' },
    { key: Industry._103, value: '鍛冶・溶接工事' },
    { key: Industry._104, value: 'テント・膜構造物工事' },
];
//鉄筋工事業
export const IndustryList_12 = [
    { key: Industry._105, value: '鉄筋加工組立て工事・鉄筋工事' },
    { key: Industry._106, value: 'ガス圧接工事' },
];
//舗装工事業
export const IndustryList_13 = [
    { key: Industry._107, value: 'アスファルト舗装工事' },
    { key: Industry._108, value: 'コンクリート舗装工事' },
    { key: Industry._109, value: 'ブロック舗装工事' },
    { key: Industry._110, value: '路盤築造工事' },
    { key: Industry._111, value: '舗装工事' },
];
//しゅんせつ工事業
export const IndustryList_14 = [
    { key: Industry._112, value: 'しゅんせつ工事・浚渫工事' },
];
//板金工事業
export const IndustryList_15 = [
    { key: Industry._113, value: '板金加工取付け工事' },
    { key: Industry._114, value: '建築板金工事' },
    { key: Industry._115, value: '板金工事' },
    { key: Industry._116, value: '金物工事' },
    { key: Industry._117, value: 'サイディング工事（金属）' },
    { key: Industry._118, value: '雨樋工事' },
];
//ガラス工事業
export const IndustryList_16 = [
    { key: Industry._119, value: 'ガラス加工取付け工事' },
    { key: Industry._120, value: 'ガラス工事' },
    { key: Industry._121, value: '窓ガラスフィルム工事' },
];
//塗装工事業
export const IndustryList_17 = [
    { key: Industry._122, value: '塗装工事' },
    { key: Industry._123, value: '溶射工事' },
    { key: Industry._124, value: 'ライニング工事' },
    { key: Industry._125, value: '布張り仕上工事' },
    { key: Industry._126, value: '鋼構造物塗装工事' },
    { key: Industry._127, value: '路面標示工事' },
    { key: Industry._128, value: '塗床工事' },
    { key: Industry._129, value: 'コーティング工事（抗菌含む）' },
    { key: Industry._130, value: '吹き付けアスベスト撤去工事（封じ込め剤塗布含む）' },
];
//防水工事業
export const IndustryList_18 = [
    { key: Industry._131, value: 'アスファルト防水工事' },
    { key: Industry._132, value: 'モルタル防水工事' },
    { key: Industry._133, value: 'シーリング工事' },
    { key: Industry._134, value: '塗膜防水工事' },
    { key: Industry._135, value: 'シート防水工事' },
    { key: Industry._136, value: '注入防水工事' },
    { key: Industry._137, value: '防水工事' },
];
//内装仕上工事業
export const IndustryList_19 = [
    { key: Industry._138, value: 'インテリア工事' },
    { key: Industry._139, value: '天井仕上工事' },
    { key: Industry._140, value: '壁張り工事' },
    { key: Industry._141, value: '内装間仕切り工事' },
    { key: Industry._142, value: '床仕上工事・床工事（OA含む）' },
    { key: Industry._143, value: 'たたみ工事' },
    { key: Industry._144, value: 'ふすま工事' },
    { key: Industry._145, value: '家具工事' },
    { key: Industry._146, value: '防音工事' },
    { key: Industry._147, value: 'クロス工事' },
    { key: Industry._148, value: '内装工事' },
    { key: Industry._149, value: '軽量ボード工事（LGS・PB）' },
    { key: Industry._150, value: 'ユニットバス工事' },
    { key: Industry._151, value: '化粧フィルム・シート工事' },
    { key: Industry._152, value: 'リペア・補修・修繕工事' },
    { key: Industry._153, value: '内装解体工事' },
    { key: Industry._154, value: 'アスベスト撤去工事（内装解体含む）' },
];
//機械器具設置工事業
export const IndustryList_20 = [
    { key: Industry._155, value: 'プラント設備工事' },
    { key: Industry._156, value: '運搬機器設置工事・昇降設備工事' },
    { key: Industry._157, value: '内燃力発電設備工事' },
    { key: Industry._158, value: '集塵機器設置工事' },
    { key: Industry._159, value: '給排気機器設置工事' },
    { key: Industry._160, value: '揚排水機器設置工事' },
    { key: Industry._161, value: 'ダム用仮設備工事' },
    { key: Industry._162, value: '遊戯施設設置工事' },
    { key: Industry._163, value: '舞台装置設置工事' },
    { key: Industry._164, value: 'サイロ設置工事' },
    { key: Industry._165, value: '立体駐車設備工事' },
];
//熱絶縁工事業
export const IndustryList_21 = [
    { key: Industry._166, value: '冷暖房設備工事' },
    { key: Industry._167, value: '冷凍冷蔵設備工事' },
    { key: Industry._168, value: 'その他熱絶縁工事（保冷・保温工事）' },
];
// 溶接工事業
export const IndustryList_22 = [
    { key: Industry._205, value: '溶接工事(造船)' },
    { key: Industry._206, value: '溶接工事(設備)' },
    { key: Industry._207, value: '溶接工事(プラント)' },
];
//さく井工事業
export const IndustryList_23 = [
    { key: Industry._169, value: 'さく井工事' },
    { key: Industry._170, value: '観測井工事' },
    { key: Industry._171, value: '還元井工事' },
    { key: Industry._172, value: '温泉掘削工事' },
    { key: Industry._173, value: '井戸築造工事' },
    { key: Industry._174, value: 'さく孔工事' },
    { key: Industry._175, value: '石油掘削工事' },
    { key: Industry._176, value: '天然ガス掘削工事' },
    { key: Industry._177, value: '揚水設備工事' },
];
//建具工事業
export const IndustryList_24 = [
    { key: Industry._178, value: '金属製建具取付け工事' },
    { key: Industry._179, value: 'サッシ取付け工事' },
    { key: Industry._180, value: '金属製カーテンウォール取付け工事' },
    { key: Industry._181, value: 'シャッター取付け工事' },
    { key: Industry._182, value: '自動ドアー取付け工事' },
    { key: Industry._183, value: '木製建具取付け工事' },
    { key: Industry._184, value: 'ふすま工事' },
    { key: Industry._185, value: '建具工事' },
];
//水道施設工事業
export const IndustryList_25 = [
    { key: Industry._186, value: '取水施設工事' },
    { key: Industry._187, value: '浄水施設工事' },
    { key: Industry._188, value: '配水施設工事' },
    { key: Industry._189, value: '下水処理設備工事' },
];
//解体工事業
export const IndustryList_26 = [
    { key: Industry._190, value: '工作物解体工事' },
    { key: Industry._191, value: '解体工事' },
];
//清掃業
export const IndustryList_27 = [
    { key: Industry._192, value: 'ハウスクリーニング' },
    { key: Industry._193, value: 'ビルメンテナンス' },
    { key: Industry._194, value: '新築美装工事・引渡清掃' },
    { key: Industry._195, value: '高圧水剥離・洗浄工事' },
    { key: Industry._196, value: 'エアコンクリーニング' },
    { key: Industry._197, value: '養生クリーニング' },
];
//測量業
export const IndustryList_28 = [
    { key: Industry._198, value: '測量' },
    { key: Industry._199, value: '墨出し' },
];
//産業廃棄物処理業
export const IndustryList_29 = [
    { key: Industry._200, value: '産業廃棄物収集運搬' },
    { key: Industry._201, value: '産業廃棄物処分' },
    { key: Industry._202, value: '特別管理産業廃棄物収集運搬' },
    { key: Industry._203, value: '特別管理産業廃棄物処分' },
];
//エクステリア業
export const IndustryList_30 = [
    { key: Industry._204, value: 'エクステリア一式工事' },
];
export const IndustryList = [
    ...IndustryList_1,
    ...IndustryList_2,
    ...IndustryList_3,
    ...IndustryList_4,
    ...IndustryList_5,
    ...IndustryList_6,
    ...IndustryList_7,
    ...IndustryList_8,
    ...IndustryList_9,
    ...IndustryList_10,
    ...IndustryList_11,
    ...IndustryList_12,
    ...IndustryList_13,
    ...IndustryList_14,
    ...IndustryList_15,
    ...IndustryList_16,
    ...IndustryList_17,
    ...IndustryList_18,
    ...IndustryList_19,
    ...IndustryList_20,
    ...IndustryList_21,
    ...IndustryList_22,
    ...IndustryList_23,
    ...IndustryList_24,
    ...IndustryList_25,
    ...IndustryList_26,
    ...IndustryList_27,
    ...IndustryList_28,
    ...IndustryList_29,
    ...IndustryList_30,
    { key: Industry._OTHER, value: 'その他工事等' },
];
export const IndustryUseSelectMulti = IndustryList.map((element) => {
    return {
        value: element.key,
        label: element.value,
    };
});
//業種の中分類
export var IndustryCatergoryEnum;
(function (IndustryCatergoryEnum) {
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_1"] = 1] = "IndustryList_1";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_2"] = 2] = "IndustryList_2";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_3"] = 3] = "IndustryList_3";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_4"] = 4] = "IndustryList_4";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_5"] = 5] = "IndustryList_5";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_6"] = 6] = "IndustryList_6";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_7"] = 7] = "IndustryList_7";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_8"] = 8] = "IndustryList_8";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_9"] = 9] = "IndustryList_9";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_10"] = 10] = "IndustryList_10";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_11"] = 11] = "IndustryList_11";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_12"] = 12] = "IndustryList_12";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_13"] = 13] = "IndustryList_13";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_14"] = 14] = "IndustryList_14";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_15"] = 15] = "IndustryList_15";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_16"] = 16] = "IndustryList_16";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_17"] = 17] = "IndustryList_17";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_18"] = 18] = "IndustryList_18";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_19"] = 19] = "IndustryList_19";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_20"] = 20] = "IndustryList_20";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_21"] = 21] = "IndustryList_21";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_22"] = 22] = "IndustryList_22";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_23"] = 23] = "IndustryList_23";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_24"] = 24] = "IndustryList_24";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_25"] = 25] = "IndustryList_25";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_26"] = 26] = "IndustryList_26";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_27"] = 27] = "IndustryList_27";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_28"] = 28] = "IndustryList_28";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_29"] = 29] = "IndustryList_29";
    IndustryCatergoryEnum[IndustryCatergoryEnum["IndustryList_30"] = 30] = "IndustryList_30";
})(IndustryCatergoryEnum || (IndustryCatergoryEnum = {}));
//業種の中分類
export const IndustryCategoryList = [
    { key: IndustryCatergoryEnum.IndustryList_1, value: "管工事業", list: IndustryList_1 },
    { key: IndustryCatergoryEnum.IndustryList_2, value: "土木工事業", list: IndustryList_2 },
    { key: IndustryCatergoryEnum.IndustryList_3, value: "建築工事業", list: IndustryList_3 },
    { key: IndustryCatergoryEnum.IndustryList_4, value: "大工工事業", list: IndustryList_4 },
    { key: IndustryCatergoryEnum.IndustryList_5, value: "左官工事業", list: IndustryList_5 },
    { key: IndustryCatergoryEnum.IndustryList_6, value: "とび・土工工事業", list: IndustryList_6 },
    { key: IndustryCatergoryEnum.IndustryList_7, value: "石工事業", list: IndustryList_7 },
    { key: IndustryCatergoryEnum.IndustryList_8, value: "屋根工事業", list: IndustryList_8 },
    { key: IndustryCatergoryEnum.IndustryList_9, value: "電気工事業", list: IndustryList_9 },
    { key: IndustryCatergoryEnum.IndustryList_10, value: "タイル、れんが、ブロック工事業", list: IndustryList_10 },
    { key: IndustryCatergoryEnum.IndustryList_11, value: "鋼構造物工事業", list: IndustryList_11 },
    { key: IndustryCatergoryEnum.IndustryList_12, value: "鉄筋工事業", list: IndustryList_12 },
    { key: IndustryCatergoryEnum.IndustryList_13, value: "舗装工事業", list: IndustryList_13 },
    { key: IndustryCatergoryEnum.IndustryList_14, value: "しゅんせつ工事業", list: IndustryList_14 },
    { key: IndustryCatergoryEnum.IndustryList_15, value: "板金工事業", list: IndustryList_15 },
    { key: IndustryCatergoryEnum.IndustryList_16, value: "ガラス工事業", list: IndustryList_16 },
    { key: IndustryCatergoryEnum.IndustryList_17, value: "塗装工事業", list: IndustryList_17 },
    { key: IndustryCatergoryEnum.IndustryList_18, value: "防水工事業", list: IndustryList_18 },
    { key: IndustryCatergoryEnum.IndustryList_19, value: "内装仕上工事業", list: IndustryList_19 },
    { key: IndustryCatergoryEnum.IndustryList_20, value: "機械器具設置工事業", list: IndustryList_20 },
    { key: IndustryCatergoryEnum.IndustryList_21, value: "熱絶縁工事業", list: IndustryList_21 },
    { key: IndustryCatergoryEnum.IndustryList_22, value: "溶接工事業", list: IndustryList_22 },
    { key: IndustryCatergoryEnum.IndustryList_23, value: "さく井工事業", list: IndustryList_23 },
    { key: IndustryCatergoryEnum.IndustryList_24, value: "建具工事業", list: IndustryList_24 },
    { key: IndustryCatergoryEnum.IndustryList_25, value: "水道施設工事業", list: IndustryList_25 },
    { key: IndustryCatergoryEnum.IndustryList_26, value: "解体工事業", list: IndustryList_26 },
    { key: IndustryCatergoryEnum.IndustryList_27, value: "清掃業", list: IndustryList_27 },
    { key: IndustryCatergoryEnum.IndustryList_28, value: "測量業", list: IndustryList_28 },
    { key: IndustryCatergoryEnum.IndustryList_29, value: "産業廃棄物処理業", list: IndustryList_29 },
    { key: IndustryCatergoryEnum.IndustryList_30, value: "エクステリア業", list: IndustryList_30 },
];
//システム設定 割引プラン
export var SettingPlanDiscountStatus;
(function (SettingPlanDiscountStatus) {
    SettingPlanDiscountStatus[SettingPlanDiscountStatus["regular"] = 0] = "regular";
    SettingPlanDiscountStatus[SettingPlanDiscountStatus["initial_discount"] = 1] = "initial_discount";
})(SettingPlanDiscountStatus || (SettingPlanDiscountStatus = {}));
//プラン日数
export const PlanPeriodDays365 = 365;
